import React, { useState, useEffect, FC, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Content from "../../layout/content/Content";
import { Card, Row, Col, Button, Spinner } from "reactstrap";
import Head from "../../layout/head/Head";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import { FormProvider, useForm } from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  DeleteOutlined,
  UploadOutlined,
  PlusSquareOutlined,
  EditOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Table,
  Collapse as AntCollapse,
  Button as AntButton,
  Descriptions,
  Modal as AntModal,
  Spin,
  Flex,
  Drawer,
  Upload,
  Select,
  Popover,
  DatePicker,
  message,
  Empty,
  Tooltip,
  Popconfirm,
} from "antd";
import dayjs from "dayjs";
import axios from "axios";
import { nanoid } from "nanoid";
import { Option } from "antd/es/mentions";
import Swal from "sweetalert2";
import CropperComponent from "../components/CropperComponent";
import SignatureModal from "../purchase-orders/SignatureModal";
import quotationApis from "../../api/master/quotations";
import { formatCurrency } from "../../utils/Utils";
import FormTextArea from "../form-components/TextAreaComponent";
import BulkMaterialUpload from "../purchase-requests/NewIndent/BulkMaterialUpload";
import ExportToXlsx from "../../utils/exportToXlsx";
import { Alert } from "reactstrap";

const { Panel } = AntCollapse;

interface PublicQuotationFormProps {
  quotationId: string;
  rfqId: string;
  userInfo: any;
  quotationData?: any; // Optional: if data is already fetched
  mode?: "create" | "edit"; // Mode: create new or edit existing
  supplierQuoteId?: string; // Required for edit mode
  onSuccess?: () => void;
  onBack?: () => void;
}

const PublicQuotationForm: FC<PublicQuotationFormProps> = ({
  quotationId,
  rfqId,
  userInfo,
  quotationData: initialQuotationData,
  mode = "create", // Default to create mode
  supplierQuoteId,
  onSuccess,
  onBack,
}) => {
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableCreateQuoteSubmit, setDisableCreateQuoteSubmit] =
    useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [OriginalData, setOriginalData] = useState<any>({});
  const [invoiceableLines, setInvoiceableLines] = useState<any>([]);
  const [tab, setTab] = useState("1");
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const [attachments, setAttachments] = useState<any>([]);
  const [documentsAttached, setDocumentsAttached] = useState<any>([]);
  const [signature, setSignature] = useState<any>([]);
  const [invoiceSignature, setInvoiceSignature] = useState<any>({});
  const [additionalCharges, setAdditionalCharges] = useState<any>([]);
  const [approvalRequired, setApprovalRequired] = useState("false");
  const [invoiceDate, setInvoiceDate] = useState<any>();
  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });
  const [currency, setCurrency] = useState({
    description: "",
    currency_code: "",
    currency_symbol: "",
    currency_format: "",
    example: "",
  });
  const [termsAndConditions, setTermsAndConditions] = useState<any>(""); // Supplier terms
  const [instructions, setInstructions] = useState(""); // Currently customer instructions
  const [customerInstructions, setCustomerInstructions] = useState(""); // Customer instructions
  const [customerTermsAndConditions, setCustomerTermsAndConditions] =
    useState<any>(""); // Customer terms
  const [supplierInstructions, setSupplierInstructions] = useState(""); // Supplier instructions
  const [customerAttachments, setCustomerAttachments] = useState<any>([]); // Customer attachments
  const [customerInstructionsVisible, setCustomerInstructionsVisible] =
    useState(false);
  const [customerTermsVisible, setCustomerTermsVisible] = useState(false);
  const [isSupplierTermsChanged, setIsSupplierTermsChanged] = useState(false);
  const [newSupplierTermsAndConditions, setNewSupplierTermsAndConditions] =
    useState<any>("");
  const [originalSupplierTermsDocId, setOriginalSupplierTermsDocId] =
    useState<any>(null);
  const [termsFormKey, setTermsFormKey] = useState(0); // Key to force form re-render
  const [deletedAttachments, setDeletedAttachments] = useState<any[]>([]);
  const [newAttachments, setNewAttachments] = useState<any[]>([]);

  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [editingKeys, setEditingKeys] = useState<string[]>([]);
  const [editingKey, setEditingKey] = useState<any | null>(null); // For view mode inline editing
  const [showSubmitBtm, setShowSubmitBtm] = useState(false); // Show submit button when changes made
  const [newNegotiableType, setNewNegotiableType] = useState<any>("");
  const [newPreferredBrands, setNewPreferredBrands] = useState<string>("");
  const [newPreferredBrandsArray, setNewPreferredBrandsArray] = useState<string[]>([]);
  const [brandOptions, setBrandOptions] = useState<any[]>([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [newValidityDate, setNewValidityDate] = useState<any>();
  const [gstType, setGstType] = useState<string>("cgst+sgst"); // GST Type: "cgst+sgst" or "igst"
  const [newPaymentDays, setNewPaymentDays] = useState<any>("");
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [editAdditionalCharges, setEditAdditionalCharges] = useState(false);
  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);
  const [selectedDeliveryAddress, setSelectedDeliveryAddress] =
    useState<any>(null);
  const [selectedNeedByDate, setSelectedNeedByDate] = useState<any>(null);
  const [needByDateList, setNeedByDateList] = useState<any>([]);
  const isEditing = (record: any) => editingKeys.includes(record.rfqLineId);
  const isEditingViewMode = (record: any) =>
    record.quotationLineId == editingKey || record.id == editingKey;
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [pricingMode, setPricingMode] = useState<string>("Base Price");
  const [paymentTerm, setPaymentTerm] = useState<string | undefined>(undefined);
  const [requiredDOC, setRequiredDOC]: any = useState([]);
  const [originalRequiredDOC, setOriginalRequiredDOC]: any = useState([]);
  const [viewMode, setViewMode] = useState(false); // Track if we're in view mode after submission
  const [submittedSupplierQuoteId, setSubmittedSupplierQuoteId] = useState<
    string | null
  >(null);
  const [isQuoted, setIsQuoted] = useState(false); // Track if quotation is created (quoted: 1)

  const [data, setData] = useState<any>([]);
  const [filterData, setFilterData] = useState<any>([]);
  const [supplierTermsAndConditions, setsupplierTermsAndConditions] =
    useState<any>("");
  const [uploadedDataErrors, setUploadedDataErrors] = useState<any>([]);
  const [uploadedDataErrorModal, setUploadedDataErrorModal] = useState(false);
  const bulkUploadErrorsRef = useRef<HTMLDivElement>(null);

  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const termsAndConditionsWatch = watch("supplierTermsAndConditions");

  useEffect(() => {
    if (termsAndConditionsWatch) {
      setsupplierTermsAndConditions(termsAndConditionsWatch);
    }
  }, [termsAndConditionsWatch]);

  // Sync newSupplierTermsAndConditions with termsAndConditions when modal opens in view mode
  useEffect(() => {
    if (termsVisible && !isSupplierTermsChanged) {
      // When modal opens in view mode, sync the state
      setNewSupplierTermsAndConditions(termsAndConditions || "");
    }
  }, [termsVisible, termsAndConditions, isSupplierTermsChanged]);

  useEffect(() => {
    setInvoiceSignature({
      isActive: false,
      image: null,
      label: "Authorised Signatory",
    });
  }, []);

  const areAllRowsFilled = () => {
    let allFilled = true;

    selectedRowKeys.forEach((key) => {
      const row = data.find((item: any) => item.quotationLineId == key);
      if (row) {
        const hsn = form.getFieldValue(`hsn_${row.rfqLineId}`);
        const price = form.getFieldValue(`price_${row.rfqLineId}`);
        const leadDays = form.getFieldValue(`leadDays_${row.rfqLineId}`);

        if (!hsn || !price || leadDays === undefined || leadDays <= 0) {
          allFilled = false;
        }
      }
    });

    return allFilled;
  };

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    pricingMode,
    ...restProps
  }: any) => {
    const isPriceEditable =
      pricingMode === "MRP" ? dataIndex !== "price" : true;
    const formInstance = Form.useFormInstance();

    const handleChange = (value: any) => {
      // Ensure value is properly parsed for CGST/SGST/IGST
      let processedValue = value;
      if (
        (dataIndex === "cgst" ||
          dataIndex === "sgst" ||
          dataIndex === "igst") &&
        value !== null &&
        value !== undefined &&
        value !== ""
      ) {
        // Parse value correctly - handle string numbers and ensure it's a valid percentage
        const parsedValue =
          typeof value === "string"
            ? parseFloat(value.replace(/[^\d.]/g, ""))
            : Number(value);
        processedValue = isNaN(parsedValue) ? null : parsedValue;
        // Prevent invalid large numbers (percentages should be 0-100)
        if (
          processedValue !== null &&
          (processedValue > 100 || processedValue < 0)
        ) {
          processedValue = null;
        }
      }

      if (viewMode) {
        form.setFieldsValue({ [dataIndex]: processedValue });
        // GST Type logic: if CGST/SGST entered, clear IGST; if IGST entered, clear CGST/SGST
        if (dataIndex === "cgst" || dataIndex === "sgst") {
          form.setFieldsValue({ igst: null });
        } else if (dataIndex === "igst") {
          form.setFieldsValue({ cgst: null, sgst: null });
        }

        // Auto-calculate price when sellingPrice or discount changes in MRP mode
        if (pricingMode === "MRP" && editing) {
          if (dataIndex === "sellingPrice" || dataIndex === "discount") {
            const sellingPrice =
              dataIndex === "sellingPrice"
                ? processedValue
                : formInstance?.getFieldValue("sellingPrice") ||
                record.sellingPrice ||
                0;
            const discount =
              dataIndex === "discount"
                ? processedValue
                : formInstance?.getFieldValue("discount") ||
                record.discount ||
                0;

            if (sellingPrice && discount !== undefined && discount !== null) {
              const calculatedPrice =
                sellingPrice - (discount * sellingPrice) / 100;
              formInstance?.setFieldValue("price", calculatedPrice);
            }
          }
        }
      } else {
        form.setFieldsValue({
          [`${dataIndex}_${record.rfqLineId}`]: processedValue,
        });
        // GST Type logic: if CGST/SGST entered, clear IGST; if IGST entered, clear CGST/SGST
        if (dataIndex === "cgst" || dataIndex === "sgst") {
          form.setFieldsValue({ [`igst_${record.rfqLineId}`]: null });
        } else if (dataIndex === "igst") {
          form.setFieldsValue({
            [`cgst_${record.rfqLineId}`]: null,
            [`sgst_${record.rfqLineId}`]: null,
          });
        }

        // Auto-calculate price when sellingPrice or discount changes in MRP mode
        if (pricingMode === "MRP" && editing) {
          if (dataIndex === "sellingPrice" || dataIndex === "discount") {
            const sellingPrice =
              dataIndex === "sellingPrice"
                ? processedValue
                : formInstance?.getFieldValue(
                  `sellingPrice_${record.rfqLineId}`
                ) ||
                record.sellingPrice ||
                0;
            const discount =
              dataIndex === "discount"
                ? processedValue
                : formInstance?.getFieldValue(`discount_${record.rfqLineId}`) ||
                record.discount ||
                0;

            if (sellingPrice && discount !== undefined && discount !== null) {
              const calculatedPrice =
                sellingPrice - (discount * sellingPrice) / 100;
              formInstance?.setFieldValue(
                `price_${record.rfqLineId}`,
                calculatedPrice
              );
            }
          }
        }
      }
    };

    // In view mode, allow editing if row is being edited
    if (viewMode && !editing) {
      return <td {...restProps}>{children}</td>;
    }

    const validateMinPurchaseQuantity = (rule: any, value: any) => {
      // In view mode, use just 'supplyQuantity', in create mode use 'supplyQuantity_rfqLineId'
      const supplyQuantity = viewMode
        ? form.getFieldValue(`supplyQuantity`) ||
        record.supplyQuantity ||
        record.suppliedQty ||
        record.quantity ||
        0
        : form.getFieldValue(`supplyQuantity_${record.rfqLineId}`) ||
        record.supplyQuantity ||
        record.quantity ||
        0;
      if (value > supplyQuantity) {
        return Promise.reject(
          `${title} should not be greater than Supply Quantity (${supplyQuantity})`
        );
      }
      return Promise.resolve();
    };

    const validateLeadDays = (rule: any, value: any) => {
      if (value <= 0) {
        return Promise.reject(`${title} must be greater than 0`);
      }
      return Promise.resolve();
    };

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={viewMode ? dataIndex : dataIndex + `_${record.rfqLineId}`}
            style={{ margin: 0 }}
            initialValue={record[dataIndex]}
            rules={
              dataIndex === "leadDays"
                ? [
                  {
                    validator: validateLeadDays,
                  },
                ]
                : dataIndex === "minPurchaseQuantity"
                  ? [
                    {
                      validator: validateMinPurchaseQuantity,
                    },
                  ]
                  : pricingMode === "MRP"
                    ? ["sellingPrice", "discount", "leadDays"].includes(dataIndex)
                      ? [
                        {
                          required:
                            dataIndex === "sellingPrice" ||
                            dataIndex === "discount",
                          message: `${title} is required`,
                        },
                        {
                          type: "number",
                          min: dataIndex === "discount" ? 0 : 1,
                          max: dataIndex === "discount" ? 100 : undefined,
                          message:
                            dataIndex === "discount"
                              ? `${title} must be between 0 and 100`
                              : `${title} must be greater than 0`,
                        },
                      ]
                      : []
                    : dataIndex === "price" ||
                      dataIndex === "supplyQuantity" ||
                      dataIndex === "minPurchaseQuantity" ||
                      dataIndex === "leadDays"
                      ? [
                        {
                          type: "number",
                          min: 1,
                          message: `${title} must be a whole number greater than 0`,
                        },
                      ]
                      : dataIndex === "cgst" ||
                        dataIndex === "igst" ||
                        dataIndex === "sgst"
                        ? [
                          {
                            type: "number",
                            min: 0,
                            message: `${title} must be greater than or equal to 0`,
                          },
                        ]
                        : []
            }
          >
            {dataIndex === "hsn" ? (
              <Form.Item
                name={viewMode ? dataIndex : dataIndex + `_${record.rfqLineId}`}
                style={{ margin: 0 }}
                rules={[
                  {
                    pattern: /^[0-9]{6,8}$/,
                    message: "HSN should be a number with 6 to 8 digits",
                  },
                ]}
              >
                <InputNumber
                  className="w-100"
                  parser={(value: any) => value.replace(/\D/g, "")}
                  onKeyPress={(event) => {
                    const regex = /^[0-9\b]+$/;
                    if (!regex.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={
                    viewMode
                      ? form.getFieldValue(dataIndex)
                      : form.getFieldValue(`${dataIndex}_${record.rfqLineId}`)
                  }
                  onChange={handleChange}
                />
              </Form.Item>
            ) : isPriceEditable ? (
              <InputNumber
                className="w-100"
                formatter={(value: any) => {
                  // Handle empty/undefined values
                  if (value === undefined || value === null || isNaN(value)) {
                    return "";
                  }
                  // For CGST/SGST/IGST: use simple formatting without Intl.NumberFormat to avoid parsing issues
                  if (
                    dataIndex === "cgst" ||
                    dataIndex === "sgst" ||
                    dataIndex === "igst"
                  ) {
                    // Return value as string, removing trailing zeros if it's a whole number
                    const numValue = Number(value);
                    if (isNaN(numValue)) return "";
                    // If it's a whole number, return without decimals; otherwise return with decimals
                    return numValue % 1 === 0
                      ? numValue.toString()
                      : numValue.toString();
                  }
                  // For other fields: Use Intl.NumberFormat
                  const hasDecimal = value.toString().includes(".");
                  return value
                    ? new Intl.NumberFormat("en-IN", {
                      style: "decimal",
                      minimumFractionDigits: hasDecimal ? 2 : 0,
                      maximumFractionDigits: hasDecimal ? 2 : 0,
                    }).format(value)
                    : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }}
                parser={(value: any) => {
                  if (!value) return "";
                  // For CGST/SGST/IGST: simple parsing - just remove non-numeric except decimal point
                  if (
                    dataIndex === "cgst" ||
                    dataIndex === "sgst" ||
                    dataIndex === "igst"
                  ) {
                    // Remove all non-numeric characters except decimal point
                    return value.toString().replace(/[^\d.]/g, "");
                  }
                  // For other fields: remove $ and commas
                  return value.replace(/\$\s?|(,*)/g, "");
                }}
                onChange={handleChange}
                disabled={
                  !viewMode &&
                  ((gstType === "cgst+sgst" && dataIndex === "igst") ||
                    (gstType === "igst" &&
                      (dataIndex === "cgst" || dataIndex === "sgst")))
                }
                min={
                  dataIndex === "cgst" ||
                    dataIndex === "igst" ||
                    dataIndex === "sgst" ||
                    dataIndex === "supplyQuantity" ||
                    dataIndex === "minPurchaseQuantity"
                    ? 0
                    : 1
                }
                step={
                  [
                    "price",
                    "supplyQuantity",
                    "minPurchaseQuantity",
                    "sellingPrice",
                    "discount",
                  ].includes(dataIndex)
                    ? 0.01
                    : 1
                }
                onKeyPress={(event) => {
                  if (
                    dataIndex === "cgst" ||
                    dataIndex === "igst" ||
                    dataIndex === "sgst" ||
                    dataIndex === "price" ||
                    dataIndex === "supplyQuantity" ||
                    dataIndex === "minPurchaseQuantity" ||
                    dataIndex === "sellingPrice" ||
                    dataIndex === "discount"
                  ) {
                    if (!/^[0-9.]+$/.test(event.key)) {
                      event.preventDefault();
                    }
                  } else {
                    if (!/^[0-9]+$/.test(event.key)) {
                      event.preventDefault();
                    }
                  }
                }}
              />
            ) : (
              children
            )}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const columns = [
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text: any, record: any, index: number) => index + 1,
    },
    {
      title: "Material",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
      fixed: "left",
    },
    {
      title: "Specification",
      dataIndex: "specification",
      key: "specification",
      width: 200,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: 150,
      render: (text: any, record: any) => `${Number(text)} ${record.uomName}`,
    },
    {
      title: "Need By Date",
      dataIndex: "needByDate",
      width: 200,
      render: (text: any, record: any) =>
        `${dayjs(text).format("DD-MMM-YYYY")}`,
    },
    {
      title: "Supply Qty",
      dataIndex: `supplyQuantity`,
      key: "supplyQuantity",
      width: 120,
      editable: true,
      render: (text: any, record: any) => {
        // Check multiple field names for the value
        const value =
          record.supplyQuantity !== null &&
            record.supplyQuantity !== undefined &&
            record.supplyQuantity !== ""
            ? Number(record.supplyQuantity)
            : record.suppliedQty !== null &&
              record.suppliedQty !== undefined &&
              record.suppliedQty !== ""
              ? Number(record.suppliedQty)
              : text !== null && text !== undefined && text !== ""
                ? Number(text)
                : null;

        // In create mode or if value is null/empty, show empty
        // In view mode with a value, show formatted number
        if (value === null || value === undefined) {
          return "";
        }
        return value.toLocaleString("en-IN", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      title: "Min Purchase Qty",
      dataIndex: `minPurchaseQuantity`,
      key: "minPurchaseQuantity",
      width: 150,
      editable: true,
      render: (text: any, record: any) => {
        // Check multiple field names for the value
        const value =
          record.minPurchaseQuantity !== null &&
            record.minPurchaseQuantity !== undefined &&
            record.minPurchaseQuantity !== ""
            ? Number(record.minPurchaseQuantity)
            : record.minQty !== null &&
              record.minQty !== undefined &&
              record.minQty !== ""
              ? Number(record.minQty)
              : text !== null && text !== undefined && text !== ""
                ? Number(text)
                : null;

        // In create mode or if value is null/empty, show empty
        // In view mode with a value, show formatted number
        if (value === null || value === undefined) {
          return "";
        }
        return value.toLocaleString("en-IN", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      title: "HSN *",
      dataIndex: `hsn`,
      key: "hsn",
      width: 120,
      editable: true,
    },
    // Add Selling Price and Discount columns before Price if pricingMode is MRP
    ...(pricingMode === "MRP"
      ? [
        {
          title: "Selling Price *",
          dataIndex: "sellingPrice",
          key: "sellingPrice",
          width: 150,
          editable: true,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {isNaN(text) ? "0.00" : formatCurrency(text, "INR")}
              </span>
            </div>
          ),
        },
        {
          title: "Discount (%) *",
          dataIndex: "discount",
          key: "discount",
          width: 150,
          editable: true,
          render: (text: any, record: any) =>
            isNaN(text) ? "0.00%" : Number(text).toFixed(2) + "%",
        },
      ]
      : []),
    {
      title: "Price *(With Out Tax)",
      dataIndex: "price",
      key: "price",
      width: 250,
      editable: pricingMode !== "MRP", // Not editable when MRP mode
      render: (text: any, record: any) => {
        // In MRP mode, calculate price from sellingPrice and discount if available
        if (pricingMode === "MRP") {
          // Check if row is being edited - get values from form
          const isRowEditing = !viewMode
            ? isEditing(record)
            : isEditingViewMode(record);

          let sellingPrice: number = 0;
          let discount: number = 0;

          if (isRowEditing) {
            // Get values from form if editing
            if (!viewMode) {
              sellingPrice =
                Number(
                  form.getFieldValue(`sellingPrice_${record.rfqLineId}`) ||
                  record.sellingPrice ||
                  0
                ) || 0;
              discount =
                Number(
                  form.getFieldValue(`discount_${record.rfqLineId}`) ||
                  record.discount ||
                  0
                ) || 0;
            } else {
              sellingPrice =
                Number(
                  form.getFieldValue("sellingPrice") || record.sellingPrice || 0
                ) || 0;
              discount =
                Number(
                  form.getFieldValue("discount") || record.discount || 0
                ) || 0;
            }
          } else {
            // Get values from record if not editing
            sellingPrice = Number(record.sellingPrice || 0) || 0;
            discount = Number(record.discount || 0) || 0;
          }

          if (sellingPrice > 0 && discount !== undefined && discount !== null) {
            const calculatedPrice =
              sellingPrice - (discount * sellingPrice) / 100;
            return (
              <div style={{ textAlign: "right" }}>
                <span>{formatCurrency(calculatedPrice, "INR")}</span>
              </div>
            );
          }
        }
        // In Base Price mode or if calculated price not available, show regular price
        return (
          <div style={{ textAlign: "right" }}>
            <span>{formatCurrency(text || 0, "INR")}</span>
          </div>
        );
      },
    },
    {
      title: "SGST (%)",
      dataIndex: "sgst",
      key: "sgst",
      width: 200,
      editable: true,
    },
    {
      title: "CGST (%)",
      dataIndex: "cgst",
      key: "cgst",
      width: 200,
      editable: true,
    },
    {
      title: "IGST (%)",
      dataIndex: "igst",
      key: "igst",
      width: 200,
      editable: true,
    },
    {
      title: "Delivery Lead Days *",
      dataIndex: "leadDays",
      key: "leadDays",
      width: 250,
      editable: true,
    },
    {
      title: "Line Total",
      dataIndex: "lineTotal",
      key: "lineTotal",
      width: 250,
      render: (text: any, record: any) => {
        // Calculate line total if not already set
        let value = Number(text) || 0;

        // If lineTotal is 0 or not set, calculate it from price, quantity, and taxes
        if (value === 0 || !text) {
          const price = Number(record.price || 0);
          const quantity = Number(
            record.supplyQuantity || record.suppliedQty || record.quantity || 0
          );
          const basicAmount = price * quantity;

          // Get GST percentages
          const cgstPercent = Number(record.cgst || 0);
          const sgstPercent = Number(record.sgst || 0);
          const igstPercent = Number(record.igst || 0);

          // Calculate tax amounts
          const cgstAmt = (basicAmount * cgstPercent) / 100;
          const sgstAmt = (basicAmount * sgstPercent) / 100;
          const igstAmt = (basicAmount * igstPercent) / 100;

          value = basicAmount + cgstAmt + sgstAmt + igstAmt;
        }

        return value.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      fixed: "right",
      render: (_: any, record: any) => {
        if (!viewMode) return null; // Only show in view mode
        const editable = isEditingViewMode(record);
        return editable ? (
          <div className="w-100 justify-content-around d-flex">
            <Button
              size="sm"
              color=""
              onClick={() => saveViewMode(record.quotationLineId || record.id)}
              style={{ marginRight: 8 }}
            >
              <Icon name="save" />
            </Button>
            <Button size="sm" color="" onClick={cancelViewMode}>
              <Icon name="cross" />
            </Button>
          </div>
        ) : (
          <Button size="sm" color="" onClick={() => editViewMode(record)}>
            <Icon name="edit" />
          </Button>
        );
      },
    },
  ];

  const mergedColumns = (columnsToMerge: any, extra?: any) => {
    const currentGstType = extra?.gstType || gstType;
    return columnsToMerge
      .filter((col: any) => {
        // Hide Line Total and Actions columns in create mode (only show in view mode)
        if (
          !viewMode &&
          (col.dataIndex === "lineTotal" || col.dataIndex === "actions")
        ) {
          return false;
        }

        // Hide Price column in create mode only when pricing mode is MRP
        if (!viewMode && col.dataIndex === "price" && pricingMode === "MRP") {
          return false;
        }

        // Filter out columns based on GST Type
        // In create mode: use gstType dropdown selection
        // In view mode: determine from data (if CGST+SGST exist, hide IGST; if IGST exists, hide CGST+SGST)
        if (!viewMode && currentGstType) {
          if (
            currentGstType === "igst" &&
            (col.dataIndex === "sgst" || col.dataIndex === "cgst")
          ) {
            return false; // Hide CGST and SGST columns when IGST is selected
          } else if (
            currentGstType === "cgst+sgst" &&
            col.dataIndex === "igst"
          ) {
            return false; // Hide IGST column when CGST+SGST is selected
          }
        } else if (viewMode) {
          // In view mode: check data to determine GST type
          // Use invoiceableLines if available, otherwise use data/filterData
          const linesToCheck =
            invoiceableLines && invoiceableLines.length > 0
              ? invoiceableLines
              : data && data.length > 0
                ? data
                : [];

          if (linesToCheck.length > 0) {
            // Check if any line has CGST or SGST values (non-null/non-zero)
            const hasCgstOrSgst = linesToCheck.some(
              (line: any) =>
                (line.cgst && line.cgst !== null && Number(line.cgst) > 0) ||
                (line.sgst && line.sgst !== null && Number(line.sgst) > 0)
            );
            // Check if any line has IGST values (non-null/non-zero)
            const hasIgst = linesToCheck.some(
              (line: any) =>
                line.igst && line.igst !== null && Number(line.igst) > 0
            );

            if (hasCgstOrSgst && col.dataIndex === "igst") {
              return false; // Hide IGST column when CGST+SGST are present
            } else if (
              hasIgst &&
              (col.dataIndex === "sgst" || col.dataIndex === "cgst")
            ) {
              return false; // Hide CGST and SGST columns when IGST is present
            }
          }
        }
        return true;
      })
      .map((col: any) => {
        if (!col.editable) {
          return col;
        }

        return {
          ...col,
          onCell: (record: any) => ({
            record,
            inputType: col.dataIndex === "quantity" ? "number" : "text",
            dataIndex: col.dataIndex,
            title: col.title,
            editing: viewMode ? isEditingViewMode(record) : isEditing(record),
            pricingMode: pricingMode,
            form: form,
            render: (text: any, record: any) => {
              // For GST fields, show percentage value only (not calculated amount)
              if (
                col.dataIndex === "sgst" ||
                col.dataIndex === "cgst" ||
                col.dataIndex === "igst"
              ) {
                // text is the percentage value (from cgst/sgst/igst field)
                // Show empty if value is null/undefined/0
                if (
                  text === null ||
                  text === undefined ||
                  text === "" ||
                  Number(text) === 0
                ) {
                  return "";
                }
                return text;
              }
              return text;
            },
          }),
        };
      });
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (!newSelectedRowKeys) {
      editingKeys.forEach((key) => {
        const row = data.find((item: any) => item.quotationLineId == key);
        form.setFieldsValue({ [`supplyQuantity_${row.rfqLineId}`]: null });
        form.setFieldsValue({ [`minPurchaseQuantity_${row.rfqLineId}`]: null });
        form.setFieldsValue({ [`hsn_${row.rfqLineId}`]: null });
        form.setFieldsValue({ [`price_${row.rfqLineId}`]: null });
        form.setFieldsValue({ [`sgst_${row.rfqLineId}`]: null });
        form.setFieldsValue({ [`cgst_${row.rfqLineId}`]: null });
        form.setFieldsValue({ [`igst_${row.rfqLineId}`]: null });
        form.setFieldsValue({ [`leadDays_${row.rfqLineId}`]: null });
      });
      setEditingKeys(() => []);
      form.resetFields();
    }
    const unSelectedRowKeys = selectedRowKeys.filter(
      (key) => !newSelectedRowKeys.includes(key)
    );
    unSelectedRowKeys?.forEach((key) => {
      const row = data.find((item: any) => item.quotationLineId == key);
      form.setFieldsValue({ [`supplyQuantity_${row.rfqLineId}`]: null });
      form.setFieldsValue({ [`minPurchaseQuantity_${row.rfqLineId}`]: null });
      form.setFieldsValue({ [`hsn_${row.rfqLineId}`]: null });
      form.setFieldsValue({ [`price_${row.rfqLineId}`]: null });
      form.setFieldsValue({ [`sgst_${row.rfqLineId}`]: null });
      form.setFieldsValue({ [`cgst_${row.rfqLineId}`]: null });
      form.setFieldsValue({ [`igst_${row.rfqLineId}`]: null });
      form.setFieldsValue({ [`leadDays_${row.rfqLineId}`]: null });
    });
    const editableRowKeys: any = [];

    newSelectedRowKeys?.forEach((key) => {
      const row = data.find((item: any) => item.quotationLineId == key);
      if (row) {
        form.setFieldsValue({
          [`supplyQuantity_${row.rfqLineId}`]: row.quantity,
          [`minPurchaseQuantity_${row.rfqLineId}`]:
            row.minPurchaseQuantity || null,
          [`hsn_${row.rfqLineId}`]: row.hsn || null,
          [`price_${row.rfqLineId}`]: row.price || null,
          [`sgst_${row.rfqLineId}`]: row.sgst || null,
          [`cgst_${row.rfqLineId}`]: row.cgst || null,
          [`igst_${row.rfqLineId}`]: row.igst || null,
          [`leadDays_${row.rfqLineId}`]: row.leadDays || null,
        });
        editableRowKeys.push(row.rfqLineId);
      }
    });
    setEditingKeys(editableRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleChangeAttachment = (info: any) => {
    let files = info.fileList.slice(-3); // Limit to 3 files
    setDocumentsAttached(files);
  };

  const beforeUpload = (file: any) => {
    const isLt5M = file.size / 1024 / 1024 <= 5;
    const isValidType = ["application/pdf", "image/jpeg", "image/png"].includes(
      file.type
    );

    if (!isLt5M) {
      Swal.fire({
        icon: "error",
        title: "File size should be less than 5MB",
      });
      return Upload.LIST_IGNORE; // Prevent file from being added
    }

    if (!isValidType) {
      Swal.fire({
        icon: "error",
        title: "File type should be pdf, jpeg or png",
      });
      return Upload.LIST_IGNORE; // Prevent file from being added
    }

    // Return false to prevent automatic upload
    return false;
  };

  const showDrawer = async () => {
    try {
      const rows = await form.validateFields();
      const invoiceLines: any = [];

      data.forEach((item: any) => {
        const isEdited = editingKeys.includes(item.rfqLineId);
        const supplyQuantity = isEdited
          ? rows[`supplyQuantity_${item.rfqLineId}`] || item.quantity
          : item.supplyQuantity || item.quantity;
        const minPurchaseQuantity = isEdited
          ? rows[`minPurchaseQuantity_${item.rfqLineId}`]
          : item.minPurchaseQuantity;
        const hsn = isEdited ? rows[`hsn_${item.rfqLineId}`] : item.hsn;

        // Get sellingPrice and discount if MRP mode
        const sellingPrice = isEdited
          ? rows[`sellingPrice_${item.rfqLineId}`]
          : item.sellingPrice;
        const discount = isEdited
          ? rows[`discount_${item.rfqLineId}`]
          : item.discount;

        // Calculate price from sellingPrice and discount if pricingMode is MRP
        let price: number = 0;
        if (pricingMode === "MRP" && sellingPrice && discount !== undefined) {
          const sp = Number(sellingPrice) || 0;
          const disc = Number(discount) || 0;
          price = sp - (disc * sp) / 100;
        } else {
          price = isEdited ? rows[`price_${item.rfqLineId}`] : item.price;
        }

        const sgstData = isEdited ? rows[`sgst_${item.rfqLineId}`] : item.sgst;
        const cgstData = isEdited ? rows[`cgst_${item.rfqLineId}`] : item.cgst;
        const igstData = isEdited
          ? rows[`igst_${item.rfqLineId}`]
          : item.igst || 0;
        const leadDays = isEdited
          ? rows[`leadDays_${item.rfqLineId}`]
          : item.leadDays;

        const basicAmount = supplyQuantity * price;
        // Calculate tax amounts from percentage values
        const sgstAmt = (basicAmount * Number(sgstData || 0)) / 100;
        const igstAmt = (basicAmount * Number(igstData || 0)) / 100;
        const cgstAmt = (basicAmount * Number(cgstData || 0)) / 100;
        const lineTotal = basicAmount + sgstAmt + igstAmt + cgstAmt;
        invoiceLines.push({
          ...item,
          supplyQuantity,
          // Store percentage values (same as API structure)
          sgst: sgstData,
          cgst: cgstData,
          igst: igstData,
          minPurchaseQuantity,
          basicAmount,
          // Store calculated amounts
          sgstData: sgstAmt,
          cgstData: cgstAmt,
          igstData: igstAmt,
          hsn,
          price,
          leadDays,
          lineTotal: lineTotal,
          grossTotal: lineTotal,
          ...(pricingMode === "MRP" && {
            sellingPrice: sellingPrice ? Number(sellingPrice) : undefined,
            discount: discount !== undefined ? Number(discount) : undefined,
          }),
        });
      });

      setInvoiceableLines(invoiceLines);
      setRequiredDOC(OriginalData?.quotationInfo?.requiredDocs);

      // Initialize form2 fields to preserve state when drawer reopens
      // For creation mode, don't auto-fill negotiable and validity date - user should enter manually
      const isEditMode =
        mode === "edit" && OriginalData?.supplierHeader?.quotationId;
      form2.setFieldsValue({
        negotiable:
          newNegotiableType ||
          (isEditMode ? OriginalData?.supplierHeader?.negotiable : undefined),
        invoiceDate:
          newValidityDate ||
          (isEditMode && OriginalData?.supplierHeader?.validityDate
            ? dayjs(OriginalData.supplierHeader.validityDate)
            : undefined),
        paymentDays:
          newPaymentDays || OriginalData?.supplierHeader?.paymentDays || "",
        supplierPreferredBrands:
          newPreferredBrandsArray.length > 0
            ? newPreferredBrandsArray
            : (() => {
                const originalValue = OriginalData?.supplierHeader?.supplierPreferredBrands;
                if (Array.isArray(originalValue) && originalValue.length > 0) {
                  return originalValue.map((b: any) => {
                    if (typeof b === "object") {
                      const id = b.brandId ?? b.id;
                      return id != null ? String(id) : (b.brandName || "");
                    }
                    return String(b);
                  }).filter(Boolean);
                }
                return [];
              })(),
      });

      setDrawerVisible(true);
    } catch (error) {
      console.log(error);
    }
  };

  const previewColumns = [
    {
      title: "Material",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
    },
    {
      title: "Specification",
      dataIndex: "specification",
      key: "specification",
      width: 200,
    },
    {
      title: "Supply Qty",
      dataIndex: "supplyQuantity",
      key: "supplyQuantity",
      width: 120,
    },
    // Add Selling Price and Discount columns before Price if pricingMode is MRP
    ...(pricingMode === "MRP"
      ? [
        {
          title: "Selling Price *",
          dataIndex: "sellingPrice",
          key: "sellingPrice",
          width: 180,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {isNaN(text) ? "0.00" : formatCurrency(text, "INR")}
              </span>
            </div>
          ),
        },
        {
          title: "Discount (%) *",
          dataIndex: "discount",
          key: "discount",
          width: 150,
          render: (text: any, record: any) =>
            isNaN(text) ? "0.00%" : Number(text).toFixed(2) + "%",
        },
      ]
      : []),
    {
      title: "Price *(With Out Tax)",
      dataIndex: "price",
      key: "price",
      width: 280,
      render: (text: any, record: any) => {
        // In MRP mode, calculate price from sellingPrice and discount if available
        if (
          pricingMode === "MRP" &&
          record.sellingPrice &&
          record.discount !== undefined
        ) {
          const sellingPrice = Number(record.sellingPrice) || 0;
          const discount = Number(record.discount) || 0;
          const calculatedPrice =
            sellingPrice - (discount * sellingPrice) / 100;
          return (
            <div style={{ textAlign: "right" }}>
              <span>{formatCurrency(calculatedPrice, "INR")}</span>
            </div>
          );
        }
        // In Base Price mode or if calculated price not available, show regular price
        return (
          <div style={{ textAlign: "right" }}>
            <span>{formatCurrency(text || 0, "INR")}</span>
          </div>
        );
      },
    },
    {
      title: "SGST (%)",
      dataIndex: "sgst",
      key: "sgst",
      width: 150,
      render: (text: any, record: any) => {
        const amount = record.sgstData;
        const percentage = text || record.sgst || 0;
        const hasAmount =
          amount !== null &&
          amount !== undefined &&
          Number(amount) > 0;
        const hasPercentage =
          percentage !== null &&
          percentage !== undefined &&
          Number(percentage) > 0;

        if (!hasAmount && !hasPercentage) {
          return (
            <div style={{ textAlign: "right" }}>
              <span>N/A</span>
            </div>
          );
        }

        const amountDisplay = hasAmount ? formatCurrency(amount, "INR") : "N/A";
        const percentageDisplay = hasPercentage ? `${percentage}%` : "N/A";

        if (amountDisplay === "N/A" && percentageDisplay === "N/A") {
          return (
            <div style={{ textAlign: "right" }}>
              <span>N/A</span>
            </div>
          );
        }

        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {amountDisplay} ({percentageDisplay})
            </span>
          </div>
        );
      },
    },
    {
      title: "CGST (%)",
      dataIndex: "cgst",
      key: "cgst",
      width: 150,
      render: (text: any, record: any) => {
        const amount = record.cgstData;
        const percentage = text || record.cgst || 0;
        const hasAmount =
          amount !== null &&
          amount !== undefined &&
          Number(amount) > 0;
        const hasPercentage =
          percentage !== null &&
          percentage !== undefined &&
          Number(percentage) > 0;

        if (!hasAmount && !hasPercentage) {
          return (
            <div style={{ textAlign: "right" }}>
              <span>N/A</span>
            </div>
          );
        }

        const amountDisplay = hasAmount ? formatCurrency(amount, "INR") : "N/A";
        const percentageDisplay = hasPercentage ? `${percentage}%` : "N/A";

        if (amountDisplay === "N/A" && percentageDisplay === "N/A") {
          return (
            <div style={{ textAlign: "right" }}>
              <span>N/A</span>
            </div>
          );
        }

        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {amountDisplay} ({percentageDisplay})
            </span>
          </div>
        );
      },
    },
    {
      title: "IGST (%)",
      dataIndex: "igst",
      key: "igst",
      width: 150,
      render: (text: any, record: any) => {
        const amount = record.igstData;
        const percentage = text || record.igst || 0;
        const hasAmount =
          amount !== null &&
          amount !== undefined &&
          Number(amount) > 0;
        const hasPercentage =
          percentage !== null &&
          percentage !== undefined &&
          Number(percentage) > 0;

        if (!hasAmount && !hasPercentage) {
          return (
            <div style={{ textAlign: "right" }}>
              <span>N/A</span>
            </div>
          );
        }

        const amountDisplay = hasAmount ? formatCurrency(amount, "INR") : "N/A";
        const percentageDisplay = hasPercentage ? `${percentage}%` : "N/A";

        if (amountDisplay === "N/A" && percentageDisplay === "N/A") {
          return (
            <div style={{ textAlign: "right" }}>
              <span>N/A</span>
            </div>
          );
        }

        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {amountDisplay} ({percentageDisplay})
            </span>
          </div>
        );
      },
    },
    {
      title: "Line Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      width: 250,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text || 0, "INR")}</span>
        </div>
      ),
    },
  ];

  const closeDrawer = () => {
    // Don't reset form fields - preserve state for next open
    setDrawerVisible(false);
  };

  const fetchOrderDetails = async () => {
    try {
      // Use fetchPublicLinkQuotationResponse API for viewing quotation data
      const res = await quotationApis.fetchPublicLinkQuotationResponse(
        Number(quotationId)
      );
      const { response, status } = res;

      if (!status || !response?.data) {
        throw new Error("Failed to fetch quotation data");
      }

      const apiData = response.data;
      const supplierInfo = apiData.supplierInfo || {};
      const supplierHeader = supplierInfo.supplierHeader || {};
      const supplierLines = supplierInfo.supplierLines || [];
      const supplierDocs = supplierInfo.supplierDocs || [];
      const supplierDms = supplierInfo.supplierDms || [];
      const quotationDms = supplierInfo.quotationDms || [];

      // Determine mode based on quoted value
      const isQuoted = apiData.quoted === 1;
      const currentSupplierQuoteId = supplierHeader.supplierQuoteId;

      // Set currency
      setCurrency({
        description: "Indian Rupee",
        currency_code: "INR",
        currency_symbol: "₹",
        currency_format: "₹#,##0.00",
        example: "INR",
      });

      // Transform billing address info to billingAddressName format
      const billingAddressName = supplierHeader.billingAddressInfo
        ? {
          deliveryLocationName:
            supplierHeader.billingAddressInfo.deliveryLocationName || "",
          addressLine1: supplierHeader.billingAddressInfo.addressLine1 || "",
          addressLine2: supplierHeader.billingAddressInfo.addressLine2 || "",
          city: supplierHeader.billingAddressInfo.cityName || "",
          cityName: supplierHeader.billingAddressInfo.cityName || "",
          pincode: supplierHeader.billingAddressInfo.pincode || "",
          state: supplierHeader.billingAddressInfo.stateName
            ? { stateName: supplierHeader.billingAddressInfo.stateName }
            : null,
          stateName: supplierHeader.billingAddressInfo.stateName || "",
          district: supplierHeader.billingAddressInfo.districtName
            ? { districtName: supplierHeader.billingAddressInfo.districtName }
            : null,
          districtName: supplierHeader.billingAddressInfo.districtName || "",
          countryInfo: supplierHeader.billingAddressInfo.countryName
            ? { countryName: supplierHeader.billingAddressInfo.countryName }
            : null,
          countryName: supplierHeader.billingAddressInfo.countryName || "",
          contactPersonName:
            supplierHeader.billingAddressInfo.contactPersonName || "",
          mobileNumber: supplierHeader.billingAddressInfo.mobileNumber || "",
          email: supplierHeader.billingAddressInfo.email || "",
        }
        : null;

      // Transform delivery address info to deliveryAddressName format
      const deliveryAddressName = supplierHeader.deliveryAddressInfo
        ? {
          deliveryLocationName:
            supplierHeader.deliveryAddressInfo.deliveryLocationName || "",
          addressLine1: supplierHeader.deliveryAddressInfo.addressLine1 || "",
          addressLine2: supplierHeader.deliveryAddressInfo.addressLine2 || "",
          city: supplierHeader.deliveryAddressInfo.cityName || "",
          cityName: supplierHeader.deliveryAddressInfo.cityName || "",
          pincode: supplierHeader.deliveryAddressInfo.pincode || "",
          state: supplierHeader.deliveryAddressInfo.stateName
            ? { stateName: supplierHeader.deliveryAddressInfo.stateName }
            : null,
          stateName: supplierHeader.deliveryAddressInfo.stateName || "",
          district: supplierHeader.deliveryAddressInfo.districtName
            ? {
              districtName: supplierHeader.deliveryAddressInfo.districtName,
            }
            : null,
          districtName: supplierHeader.deliveryAddressInfo.districtName || "",
          countryInfo: supplierHeader.deliveryAddressInfo.countryName
            ? { countryName: supplierHeader.deliveryAddressInfo.countryName }
            : null,
          countryName: supplierHeader.deliveryAddressInfo.countryName || "",
          contactPersonName:
            supplierHeader.deliveryAddressInfo.contactPersonName || "",
          mobileNumber: supplierHeader.deliveryAddressInfo.mobileNumber || "",
          email: supplierHeader.deliveryAddressInfo.email || "",
        }
        : null;

      // Transform header data
      const transformedHeader = {
        rfqId: supplierHeader.rfqId,
        quotationId: supplierHeader.quotationId,
        orgName: supplierHeader.orgName,
        siteName: supplierHeader.siteName,
        gstin: supplierHeader.gstin,
        quotationDescription: supplierHeader.quotationDescription,
        quotationFor: supplierHeader.quotationFor,
        preferredBrands: supplierHeader.preferredBrands,
        lastSubmissionDate: supplierHeader.lastSubmissionDate,
        deadlineType: supplierHeader.deadlineType,
        additionalCharges: supplierHeader.additionalCharges,
        paymentTerms: supplierHeader.paymentTerms,
        expectedCreditDays: supplierHeader.expectedCreditDays,
        deliveryDateType: supplierHeader.deliveryDateType,
        deliveryLevelType: supplierHeader.deliveryLevelType,
        needByDate: supplierHeader.needByDate,
        billingAddressInfo: supplierHeader.billingAddressInfo,
        billingAddressName: billingAddressName,
        deliveryAddressInfo: supplierHeader.deliveryAddressInfo,
        deliveryAddressName: deliveryAddressName,
        // Add supplier quote specific fields if quoted
        ...(isQuoted && {
          supplierQuoteId: supplierHeader.supplierQuoteId,
          referencedSupplierId: supplierHeader.referencedSupplierId,
          version: supplierHeader.version,
          latest: supplierHeader.latest,
          status: supplierHeader.status,
          negotiable: supplierHeader.negotiable,
          approvalRequired: supplierHeader.approvalRequired,
          paymentDays: supplierHeader.paymentDays,
          paymentPercentage: supplierHeader.paymentPercentage,
          quotedDate: supplierHeader.quotedDate,
          signatureLabel: supplierHeader.signatureLabel,
          supplierPreferredBrands: supplierHeader.supplierPreferredBrands,
          totalAdditionalCharges: supplierHeader.totalAdditionalCharges,
          additionalChargesArray: supplierHeader.additionalChargesArray,
          netTotal: supplierHeader.netTotal,
          gross: supplierHeader.gross,
          cgst: supplierHeader.cgst,
          sgst: supplierHeader.sgst,
          igst: supplierHeader.igst,
        }),
      };

      // Set original data structure
      setOriginalData({
        quotationInfo: {
          quotationHeader: transformedHeader,
          requiredDocs: supplierDocs.map((doc: any) => ({
            quotationDocNameId: doc.quotationDocNameId,
            documentName: doc.documentName,
            mandatory: doc.mandatory,
            latest: doc.latest,
            supplierDocQuoteId: doc.supplierDocQuoteId,
            dms: doc.dms || [],
          })),
        },
        // Also set supplierHeader separately for easy access in view mode updates
        ...(isQuoted && {
          supplierHeader: {
            supplierQuoteId: supplierHeader.supplierQuoteId,
            quotationId: supplierHeader.quotationId,
            rfqId: supplierHeader.rfqId,
            orgId: supplierHeader.orgId,
            referencedSupplierId: supplierHeader.referencedSupplierId,
            supplierId: supplierHeader.supplierId,
            version: supplierHeader.version,
            latest: supplierHeader.latest,
            status: supplierHeader.status,
            negotiable: supplierHeader.negotiable,
            validityDate: supplierHeader.validityDate,
            paymentTerms: supplierHeader.paymentTerms,
            paymentDays: supplierHeader.paymentDays,
            paymentPercentage: supplierHeader.paymentPercentage,
            approvalRequired: supplierHeader.approvalRequired,
            signatureLabel: supplierHeader.signatureLabel,
            supplierPreferredBrands: supplierHeader.supplierPreferredBrands,
            totalAdditionalCharges: supplierHeader.totalAdditionalCharges,
            additionalChargesArray: supplierHeader.additionalChargesArray,
            netTotal: supplierHeader.netTotal,
            gross: supplierHeader.gross,
            cgst: supplierHeader.cgst,
            sgst: supplierHeader.sgst,
            igst: supplierHeader.igst,
            pricingMode: supplierHeader.pricingMode,
            createdBy: supplierHeader.createdBy,
            createdAt: supplierHeader.createdAt,
            tncChecked: supplierHeader.tncChecked,
          },
        }),
      });

      // Sync supplierQuoteId from API response so payload always uses latest
      if (supplierHeader?.supplierQuoteId) {
        setSubmittedSupplierQuoteId(
          String(supplierHeader.supplierQuoteId)
        );
      }

      // Extract and set pricingMode
      const pricingModeValue =
        supplierHeader.pricingMode ||
        apiData?.quotationInfo?.quotationHeader?.pricingMode ||
        "Base Price";
      setPricingMode(pricingModeValue);

      // Set required documents
      const requiredDocsData = supplierDocs.map((doc: any) => {
        // Deduplicate dms array by docId and fileName
        const uniqueDms = (doc.dms || []).filter(
          (file: any, index: number, self: any[]) => {
            if (file.docId) {
              return (
                index === self.findIndex((f: any) => f.docId === file.docId)
              );
            }
            if (file.fileName) {
              return (
                index ===
                self.findIndex(
                  (f: any) => f.fileName === file.fileName && !f.docId
                )
              );
            }
            return true;
          }
        );
        return {
          quotationDocNameId: doc.quotationDocNameId,
          documentName: doc.documentName,
          mandatory: doc.mandatory,
          latest: doc.latest,
          supplierDocQuoteId: doc.supplierDocQuoteId,
          dms: uniqueDms,
        };
      });
      setRequiredDOC(requiredDocsData);
      setOriginalRequiredDOC(JSON.parse(JSON.stringify(requiredDocsData))); // Deep copy for comparison

      // Transform line items
      const transformedLines = supplierLines.map((item: any) => {
        const lineItem: any = {
          quotationLineId: item.quotationLineId,
          rfqLineId: item.rfqLineId,
          materialId: item.materialId,
          materialName: item.materialName,
          categoryId: item.categoryId,
          categoryName: item.categoryName,
          uomId: item.uomId,
          uomName: item.uomName,
          specification: item.specification,
          quantity: parseFloat(item.quantity || 0),
          needByDate: item.needByDate,
          deliveryAddressId: item.deliveryAddressId,
          deliveryAddressInfo: item.deliveryAddressInfo,
          dms: item.dms || [],
        };

        // Add supplier quote line data if quoted
        if (isQuoted) {
          lineItem.supplierQuoteLineId = item.supplierQuoteLineId;
          lineItem.supplierQuoteId = item.supplierQuoteId;
          lineItem.referencedSupplierId = item.referencedSupplierId;
          lineItem.latest = item.latest;
          lineItem.version = item.version;
          lineItem.supplyQuantity = parseFloat(item.suppliedQty || 0);
          lineItem.minPurchaseQuantity = parseFloat(item.minQty || 0);
          lineItem.hsn = item.hsn;
          lineItem.price = parseFloat(item.price || 0);
          // Store percentage values (from API) - use null if 0 to show empty fields
          // API returns values like "2.500000" which are percentage values
          const cgstVal = item.cgst ? parseFloat(item.cgst) : 0;
          const sgstVal = item.sgst ? parseFloat(item.sgst) : 0;
          const igstVal = item.igst ? parseFloat(item.igst) : 0;
          lineItem.cgst = cgstVal !== 0 ? cgstVal : null;
          lineItem.sgst = sgstVal !== 0 ? sgstVal : null;
          lineItem.igst = igstVal !== 0 ? igstVal : null;
          lineItem.leadDays = item.leadDays;
          lineItem.lineTotal = parseFloat(item.lineTotal || 0);
          // Add sellingPrice and discount if available (for MRP mode)
          if (item.sellingPrice !== undefined && item.sellingPrice !== null) {
            lineItem.sellingPrice = parseFloat(item.sellingPrice);
          }
          if (item.discount !== undefined && item.discount !== null) {
            lineItem.discount = parseFloat(item.discount);
          }
        } else {
          // Create mode - initialize empty values
          lineItem.supplyQuantity = null;
          lineItem.minPurchaseQuantity = null;
          lineItem.hsn = null;
          lineItem.price = null;
          lineItem.cgst = null;
          lineItem.sgst = null;
          lineItem.igst = null;
          lineItem.leadDays = null;
        }

        return lineItem;
      });

      setMaterialData(transformedLines);
      setData(transformedLines);
      setFilterData(transformedLines);

      // Set delivery address list
      const _DeliveryAddressList: any = [];
      transformedLines.forEach((item: any) => {
        if (
          transformedHeader.deliveryDateType === "LINE_LEVEL" &&
          item.deliveryAddressInfo &&
          !_DeliveryAddressList.find(
            (addr: any) => addr.id === item.deliveryAddressInfo.id
          )
        ) {
          _DeliveryAddressList.push(item.deliveryAddressInfo);
        }
      });
      setDeliveryAddressList(_DeliveryAddressList);

      // Set additional charges if quoted
      if (isQuoted && supplierHeader.additionalChargesArray) {
        setAdditionalCharges(
          supplierHeader.additionalChargesArray.map((charge: any) => {
            const id = nanoid(4);
            form2.setFieldsValue({
              [`AdditionalCharges.${id}.name`]: charge?.name,
              [`AdditionalCharges.${id}.price`]: Number(charge?.price),
            });
            return {
              ...charge,
              id,
            };
          })
        );
      }

      // Set signature from supplierDms
      const signatureDoc = supplierDms.find(
        (doc: any) => doc.moduleFileType === "signature"
      );
      if (signatureDoc) {
        setInvoiceSignature({
          docId: signatureDoc.docId,
          image: signatureDoc.filePath,
          label: supplierHeader.signatureLabel || "Authorised Signatory",
          isActive: true,
        });
      }

      // Set customer attachments from quotationDms
      const customerAttachmentDocs = quotationDms.filter(
        (doc: any) => doc.moduleFileType === "attachments"
      );
      if (customerAttachmentDocs.length > 0) {
        setCustomerAttachments(
          customerAttachmentDocs.map((doc: any) => ({
            docId: doc.docId,
            name: doc.fileName,
            link: doc.filePath,
            moduleFileType: doc.moduleFileType,
            module: doc.module,
            label: "attachments",
            isActive: true,
          }))
        );
      }

      // Set supplier attachments from supplierDms
      const supplierAttachmentDocs = supplierDms.filter(
        (doc: any) => doc.moduleFileType === "attachments"
      );
      if (supplierAttachmentDocs.length > 0) {
        setAttachments(
          supplierAttachmentDocs.map((doc: any) => ({
            docId: doc.docId,
            name: doc.fileName,
            link: doc.filePath,
            moduleFileType: doc.moduleFileType,
            module: doc.module,
            label: "attachments",
            isActive: true,
          }))
        );
      }

      // Set customer terms and conditions from quotationDms
      const customerTermsDoc = quotationDms.find(
        (doc: any) => doc.moduleFileType === "termsAndConditions"
      );
      if (customerTermsDoc) {
        try {
          const termsHtml = await fetchHtmlContentFromUrl(
            customerTermsDoc.filePath
          );
          setCustomerTermsAndConditions(termsHtml);
        } catch (error) {
          console.error("Error fetching customer terms and conditions:", error);
        }
      }

      // Set supplier terms and conditions from supplierDms
      const supplierTermsDoc = supplierDms.find(
        (doc: any) => doc.moduleFileType === "termsAndConditions"
      );
      if (supplierTermsDoc) {
        try {
          const termsHtml = await fetchHtmlContentFromUrl(
            supplierTermsDoc.filePath
          );
          setTermsAndConditions(termsHtml);
          setNewSupplierTermsAndConditions(termsHtml);
          setOriginalSupplierTermsDocId(supplierTermsDoc.docId || null);
        } catch (error) {
          console.error("Error fetching supplier terms and conditions:", error);
        }
      } else {
        setOriginalSupplierTermsDocId(null);
      }

      // Reset original supplier terms doc ID after successful update
      if (originalSupplierTermsDocId && isSupplierTermsChanged) {
        setOriginalSupplierTermsDocId(null);
      }

      // Set customer instructions from quotationDms
      const customerInstructionsDoc = quotationDms.find(
        (doc: any) => doc.moduleFileType === "instructions"
      );
      if (customerInstructionsDoc) {
        try {
          const instructionsHtml = await fetchHtmlContentFromUrl(
            customerInstructionsDoc.filePath
          );
          setCustomerInstructions(instructionsHtml);
          setInstructions(instructionsHtml); // Keep for backward compatibility
        } catch (error) {
          console.error("Error fetching customer instructions:", error);
        }
      }

      // Set supplier instructions from supplierDms
      const supplierInstructionsDoc = supplierDms.find(
        (doc: any) => doc.moduleFileType === "instructions"
      );
      if (supplierInstructionsDoc) {
        try {
          const instructionsHtml = await fetchHtmlContentFromUrl(
            supplierInstructionsDoc.filePath
          );
          setSupplierInstructions(instructionsHtml);
        } catch (error) {
          console.error("Error fetching supplier instructions:", error);
        }
      }

      // Set required docs
      if (supplierDocs && supplierDocs.length > 0) {
        setRequiredDOC(supplierDocs);
      }

      // If quoted, set view mode and isQuoted state
      setIsQuoted(isQuoted);
      if (isQuoted) {
        setViewMode(true);
        // Populate invoiceableLines for view mode calculations
        const viewModeLines = transformedLines.map((item: any) => {
          const lineTotal =
            Number(item.price || 0) * Number(item.supplyQuantity || 0);
          // Get percentage values (from API - these are what should be displayed in table)
          const cgstPercentage = item.cgst || 0;
          const sgstPercentage = item.sgst || 0;
          const igstPercentage = item.igst || 0;
          // Calculate tax amounts from percentage values (for totals)
          const cgstAmt = (lineTotal * Number(cgstPercentage)) / 100;
          const sgstAmt = (lineTotal * Number(sgstPercentage)) / 100;
          const igstAmt = (lineTotal * Number(igstPercentage)) / 100;

          return {
            ...item,
            quotationLineId: item.quotationLineId,
            id: item.supplierQuoteLineId || item.quotationLineId,
            supplyQuantity: item.supplyQuantity,
            price: item.price,
            // Store percentage values (for display in table columns) - these are what user sees/edits
            cgst: item.cgst || null,
            sgst: item.sgst || null,
            igst: item.igst || null,
            // Store calculated amounts (for totals calculation and display)
            cgstData: cgstAmt,
            sgstData: sgstAmt,
            igstData: igstAmt,
            basicAmount: lineTotal,
            grossTotal: lineTotal + cgstAmt + sgstAmt + igstAmt,
            suppliedQty: item.supplyQuantity,
            minQty: item.minPurchaseQuantity,
            // Add sellingPrice and discount for MRP mode
            sellingPrice:
              item.sellingPrice !== undefined && item.sellingPrice !== null
                ? parseFloat(item.sellingPrice)
                : undefined,
            discount:
              item.discount !== undefined && item.discount !== null
                ? parseFloat(item.discount)
                : undefined,
          };
        });
        setInvoiceableLines(viewModeLines);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const ViewTableTotals = ({
    data,
    additionalCharges,
    invoice,
    currency,
  }: any) => {
    let totalNetAmount = 0,
      cgst = 0,
      sgst = 0,
      igst = 0,
      totalAmount = 0;

    data?.forEach((item: any) => {
      // Calculate price: in MRP mode, use sellingPrice and discount if available
      let itemPrice = Number(item.price || 0);
      if (
        item.sellingPrice !== undefined &&
        item.sellingPrice !== null &&
        item.discount !== undefined &&
        item.discount !== null
      ) {
        // Calculate discounted price from sellingPrice and discount
        const sellingPrice = Number(item.sellingPrice) || 0;
        const discount = Number(item.discount) || 0;
        itemPrice = sellingPrice - (discount * sellingPrice) / 100;
      }

      const totalAmountForItem =
        Number(item.suppliedQty || item.supplyQuantity || 0) * itemPrice;
      cgst = cgst + (totalAmountForItem * Number(item.cgst || 0)) / 100;
      sgst = sgst + (totalAmountForItem * Number(item.sgst || 0)) / 100;
      igst = igst + (totalAmountForItem * Number(item.igst || 0)) / 100;
      totalNetAmount += totalAmountForItem;
    });

    totalAmount = totalNetAmount + cgst + sgst + igst;

    // Additional charges, if any
    additionalCharges?.forEach((item: any) => {
      if (item.price) {
        totalAmount += Number(item.price);
      }
    });

    return (
      <Row
        className={`${invoice ? "w-50 mt-2" : ""}`}
        style={{ margin: "20px" }}
      >
        <Col className={`justify-end`}>
          <div className={`${invoice ? "w-100" : "w-40"}`}>
            <div className="d-flex justify-content-between">
              <div className="w-50 justify-end">
                <strong>Taxable Amount</strong>
              </div>
              <span className="r_align">
                {formatCurrency(totalNetAmount, "INR")}
              </span>
            </div>
            {cgst && sgst ? (
              <>
                <div className="d-flex justify-content-between">
                  <div className="w-50 justify-end">
                    <strong>CGST</strong>
                  </div>
                  <span className="r_align">{formatCurrency(cgst, "INR")}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="w-50 justify-end">
                    <strong>SGST</strong>
                  </div>
                  <span className="r_align">{formatCurrency(sgst, "INR")}</span>
                </div>
              </>
            ) : (
              <div className="d-flex justify-content-between">
                <div className="w-50 justify-end">
                  <strong>IGST</strong>
                </div>
                <span className="r_align">{formatCurrency(igst, "INR")}</span>
              </div>
            )}
            {additionalCharges?.map((item: any) =>
              item.price ? (
                <div className="d-flex justify-content-between" key={item.name}>
                  <div className="w-50 justify-end">
                    <strong>{item.name}</strong>
                  </div>
                  <span className="r_align">
                    {formatCurrency(item.price, "INR")}
                  </span>
                </div>
              ) : null
            )}
            <div
              className="d-flex justify-content-between"
              style={{ fontSize: "18px", marginTop: "10px" }}
            >
              <div className="w-50 justify-end">
                <strong>Total</strong>
              </div>
              <strong className="r_align">
                {formatCurrency(totalAmount, "INR")}
              </strong>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
    fetchBrandsFromQuotationApi();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, [quotationId]);

  const fetchBrandsFromQuotationApi = async () => {
    if (!quotationId) return;
    try {
      const res: any = await quotationApis.fetchPublicLinkQuotationResponse(
        Number(quotationId)
      );
      const { response, status } = res || {};
      const data = response?.data || res?.data;
      if (!status || !data) return;

      const brandsRaw =
        data.preferredBrands ||
        data.quotationInfo?.quotationHeader?.preferredBrands ||
        data.supplierInfo?.supplierHeader?.preferredBrands ||
        data.brands ||
        data.brandList ||
        [];
      const brandsList = Array.isArray(brandsRaw) ? brandsRaw : [];

      const toOption = (b: any) => {
        if (typeof b === "string") return { label: b, value: b };
        const label = b.brandName || b.name || b.label || "";
        const value = (b.brandId || b.id || b.value || label).toString();
        return { label: label || value, value };
      };

      const optionsMap = new Map<string, { label: string; value: string }>();
      brandsList.forEach((b: any) => {
        const opt = toOption(b);
        if (opt.value) optionsMap.set(opt.value, opt);
      });

      const supplierPreferred =
        data.supplierInfo?.supplierHeader?.supplierPreferredBrands || [];
      const supplierList = Array.isArray(supplierPreferred) ? supplierPreferred : [];
      supplierList.forEach((b: any) => {
        const opt = toOption(b);
        if (opt.value && !optionsMap.has(opt.value)) {
          optionsMap.set(opt.value, opt);
        }
      });

      setBrandOptions(Array.from(optionsMap.values()));
    } catch (error) {
      console.log(error);
    }
  };

  const buildSupplierPreferredBrandsPayload = (values: string[]) =>
    values.map((val) => {
      const opt = brandOptions.find((o) => o.value === val);
      if (opt) {
        return { brandId: val, brandName: opt.label };
      }
      return { brandId: null, brandName: val };
    });

  // Sync preferred brands from OriginalData when data loads
  useEffect(() => {
    const preferredBrandsValue =
      OriginalData?.supplierHeader?.supplierPreferredBrands ||
      OriginalData?.quotationInfo?.quotationHeader?.preferredBrands;
    if (Array.isArray(preferredBrandsValue) && preferredBrandsValue.length > 0) {
      const valueIds = preferredBrandsValue.map((brand: any) => {
        if (typeof brand === "object") {
          if (brand.brandId || brand.id) return (brand.brandId || brand.id)?.toString();
          if (brand.brandName) return brand.brandName;
        }
        const fromOptions = brandOptions.find(
          (opt) => opt.value === brand || opt.label === brand
        );
        return fromOptions?.value || (typeof brand === "string" ? brand : "");
      }).filter(Boolean);
      const formatted = preferredBrandsValue.map((brand: any) => {
        if (typeof brand === "object") {
          const hasId = brand.brandId || brand.id;
          return {
            brandId: hasId ? (brand.brandId || brand.id)?.toString() : null,
            brandName: brand.brandName || brand.name || "",
          };
        }
        return { brandId: null, brandName: typeof brand === "string" ? brand : "" };
      });
      setNewPreferredBrandsArray(valueIds);
      setNewPreferredBrands(JSON.stringify(formatted));
      form2?.setFieldValue("supplierPreferredBrands", valueIds);
    }
  }, [OriginalData?.supplierHeader?.supplierPreferredBrands, OriginalData?.quotationInfo?.quotationHeader?.preferredBrands, brandOptions]);

  const handlePreferredBrandsChange = (
    value: string[],
    showSubmitBtn?: boolean
  ) => {
    setNewPreferredBrandsArray(value);
    const formatted = buildSupplierPreferredBrandsPayload(value);
    setNewPreferredBrands(JSON.stringify(formatted));
    form2?.setFieldValue("supplierPreferredBrands", value);
    if (showSubmitBtn) setShowSubmitBtm(true);
  };

  const ShowBillingAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressline1,
      addressLine2,
      addressline2,
      city,
      cityName,
      pincode,
      state,
      stateName,
      district,
      districtName,
      countryInfo,
      countryName,
    } = address;

    // Handle both formats (API response format and old format)
    const locationName = deliveryLocationName || "";
    const line1 = addressLine1 || addressline1 || "";
    const line2 = addressLine2 || addressline2 || "";
    const cityName_ = city || cityName || "";
    const stateName_ = state?.stateName || stateName || "";
    const districtName_ = district?.districtName || districtName || "";
    const countryName_ = countryInfo?.countryName || countryName || "India";

    return (
      <ul>
        <li>
          <strong>{locationName}</strong>
        </li>
        <li>
          {line1}
          {line2 ? `, ${line2}` : ""}
        </li>
        <li>
          {cityName_}
          {districtName_ ? `, ${districtName_}` : ""}
          {stateName_ ? `, ${stateName_}` : ""}
          {countryName_ ? `, ${countryName_}` : ""} - {pincode}
        </li>
      </ul>
    );
  };

  const ShowDeliveryAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressline1,
      addressLine2,
      addressline2,
      city,
      cityName,
      pincode,
      state,
      stateName,
      district,
      districtName,
      countryInfo,
      countryName,
    } = address;

    // Handle both formats (API response format and old format)
    const locationName = deliveryLocationName || "";
    const line1 = addressLine1 || addressline1 || "";
    const line2 = addressLine2 || addressline2 || "";
    const cityName_ = city || cityName || "";
    const stateName_ = state?.stateName || stateName || "";
    const districtName_ = district?.districtName || districtName || "";
    const countryName_ = countryInfo?.countryName || countryName || "India";

    return (
      <ul>
        <li>
          <strong>{locationName}</strong>
        </li>
        <li>
          {line1}
          {line2 ? `, ${line2}` : ""}
        </li>
        <li>
          {cityName_}
          {districtName_ ? `, ${districtName_}` : ""}
          {stateName_ ? `, ${stateName_}` : ""}
          {countryName_ ? `, ${countryName_}` : ""} - {pincode}
        </li>
        {(address.contactPersonName || address.mobileNumber) && (
          <li>
            Contact: {address.contactPersonName || ""}
            {address.mobileNumber ? ` - ${address.mobileNumber}` : ""}
          </li>
        )}
      </ul>
    );
  };

  const uploadProps = {
    beforeUpload: (file: any) => {
      return false;
    },
    maxCount: 1,
  };

  useEffect(() => {
    let _filterData = data;
    if (selectedNeedByDate) {
      _filterData = _filterData.filter(
        (item: any) => item.needByDate == selectedNeedByDate
      );
    }
    if (selectedDeliveryAddress) {
      _filterData = _filterData.filter(
        (item: any) => item.deliveryAddressId == selectedDeliveryAddress
      );
    }
    setFilterData(_filterData);
  }, [selectedDeliveryAddress, selectedNeedByDate, data]);

  const createInvoice = async (Data: any) => {
    try {
      const _formData = new FormData();
      const supplierApprovals: any = approvals?.data;
      const newfiledata: any[] = [];
      const deletedFileData: any[] = [];

      // Track deleted signature if it existed before but was removed
      if (mode === "edit" && OriginalData?.supplierHeader?.dms) {
        const existingSignature = OriginalData.supplierHeader.dms.find(
          (item: any) => item.moduleFileType === "signature"
        );
        if (
          existingSignature &&
          !invoiceSignature?.image &&
          invoiceSignature?.docId
        ) {
          deletedFileData.push({
            docId: invoiceSignature.docId,
          });
        }
      }

      if (supplierTermsAndConditions) {
        const termsAndConditionsFile = new Blob([supplierTermsAndConditions], {
          type: "text/html",
        });
        _formData.append(
          `files`,
          new File([termsAndConditionsFile], "termsAndConditions.html", {
            type: "text/html",
          })
        );
        newfiledata.push({
          fileIndex: newfiledata.length,
          module: "Quotations",
          moduleFileType: "termsAndConditions",
          level: "HEADER_LEVEL",
        });
      }

      if (Data?.attachDC) {
        Data?.attachDC?.forEach((item: any) => {
          _formData.append(`files`, item?.originFileObj);
          newfiledata.push({
            fileIndex: newfiledata.length,
            module: "Quotations",
            moduleFileType: "attachments",
            level: "HEADER_LEVEL",
          });
        });
      }

      const docEntries = Object.entries(Data).filter(([key]) =>
        key.startsWith("doc_")
      );

      docEntries.forEach(([key, value]: any, index) => {
        const docNumberStr = key.slice(4);
        const docNumber = parseInt(docNumberStr, 10);
        if (!isNaN(docNumber) && value && value.length > 0) {
          newfiledata.push({
            quotationDocNameId: docNumber,
            fileIndex: newfiledata.length,
            module: "Quotations",
            moduleFileType: "Supplier Docs",
            level: "LINE_LEVEL",
          });
          if (value[0]) {
            _formData.append(`files`, new File([value[0]], value[0]?.name));
          }
        }
      });

      delete Data.attachDC;
      const keysToDelete = Object.keys(Data).filter((key) =>
        key.startsWith("doc_")
      );
      keysToDelete.forEach((key) => {
        delete Data[key];
      });

      let validityDate = dayjs(Data?.invoiceDate).format("YYYY-MM-DD");
      let paymentPercentage = Data?.advancePercentage;
      delete Data.invoiceDate;
      delete Data.advancePercentage;

      // Approvals field removed - always set to "N"
      let approvalRequired = "N";

      let totalNetAmount = 0,
        cgst = 0,
        sgst = 0,
        igst = 0,
        totalAmount = 0;

      invoiceableLines?.forEach((item: any) => {
        const totalAmountForItem = item.price * item.supplyQuantity;
        // Read percentage values from cgstData/sgstData/igstData fields (percentages stored in showDrawer)
        const cgstRate = isNaN(Number(item?.cgstData))
          ? 0
          : Number(item?.cgstData);
        const sgstRate = isNaN(Number(item?.sgstData))
          ? 0
          : Number(item?.sgstData);
        const igstRate = isNaN(Number(item?.igstData))
          ? 0
          : Number(item?.igstData);

        const itemCGST = (totalAmountForItem * cgstRate) / 100;
        const itemSGST = (totalAmountForItem * sgstRate) / 100;
        const itemIGST = (totalAmountForItem * igstRate) / 100;

        totalNetAmount += totalAmountForItem;
        cgst += itemCGST;
        sgst += itemSGST;
        igst += itemIGST;
      });

      // Get latest supplierQuoteId from API (fetchPublicLinkQuotationResponse) for payload
      const latestSupplierQuoteId =
        OriginalData?.supplierHeader?.supplierQuoteId ||
        submittedSupplierQuoteId ||
        OriginalData?.quotationInfo?.quotationHeader?.supplierQuoteId ||
        null;

      // Calculate CGST, SGST, IGST amounts for lines
      // Restructure lines array to match required API format
      const lines = (invoiceableLines || []).map((item: any) => {
        const lineTotal = item.price * item.supplyQuantity;

        // Apply GST Type logic: if IGST exists, CGST and SGST should be 0; if CGST+SGST exists, IGST should be 0
        // Read percentage values from cgst/sgst/igst fields
        let finalCgst = isNaN(Number(item?.cgst)) ? 0 : Number(item?.cgst);
        let finalSgst = isNaN(Number(item?.sgst)) ? 0 : Number(item?.sgst);
        let finalIgst = isNaN(Number(item?.igst)) ? 0 : Number(item?.igst);

        if (finalIgst > 0) {
          // If IGST exists, clear CGST and SGST
          finalCgst = 0;
          finalSgst = 0;
        } else if (finalCgst > 0 || finalSgst > 0) {
          // If CGST or SGST exists, clear IGST
          finalIgst = 0;
        }

        const cgstAmt = (lineTotal * finalCgst) / 100;
        const sgstAmt = (lineTotal * finalSgst) / 100;
        const igstAmt = (lineTotal * finalIgst) / 100;
        const lineTotalWithTax = lineTotal + cgstAmt + sgstAmt + igstAmt;

        const lineItem: any = {
          hsn: item.hsn || "",
          minQty: Number(item.minPurchaseQuantity || 0),
          cgst: Number(finalCgst || 0),
          quotationId:
            mode === "edit" && OriginalData?.supplierHeader?.quotationId
              ? OriginalData.supplierHeader.quotationId
              : OriginalData.quotationInfo.quotationHeader.quotationId,
          price: Number(item.price || 0),
          uomId: item.uomId || item.uom || null,
          lineTotal: Number(lineTotalWithTax.toFixed(2)),
          leadDays: Number(item.leadDays || 0),
          sgst: Number(finalSgst || 0),
          suppliedQty: Number(item.supplyQuantity || 0),
          quotationLineId: item.quotationLineId,
          igst: Number(finalIgst || 0),
        };

        if (latestSupplierQuoteId) {
          lineItem.supplierQuoteId = latestSupplierQuoteId;
        }

        // Add sellingPrice and discount if pricingMode is MRP
        if (pricingMode === "MRP") {
          if (item.sellingPrice !== undefined && item.sellingPrice !== null) {
            lineItem.sellingPrice = Number(item.sellingPrice);
          }
          if (item.discount !== undefined && item.discount !== null) {
            lineItem.discount = Number(item.discount);
          }
        }

        return lineItem;
      });

      totalAmount = totalNetAmount + cgst + sgst + igst;

      // Get supplierId from userInfo or OriginalData
      const supplierIdValue =
        OriginalData?.supplierHeader?.referencedSupplierId ||
        OriginalData?.supplierHeader?.supplierId ||
        userInfo?.supplierId ||
        userInfo?.registrationData?.supplierId ||
        null;

      // Restructure header object to match required API format
      const header: any = {
        quotationId:
          mode === "edit" && OriginalData?.supplierHeader?.quotationId
            ? OriginalData.supplierHeader.quotationId
            : OriginalData.quotationInfo.quotationHeader.quotationId,
        rfqId: OriginalData.quotationInfo.quotationHeader.rfqId,
        supplierId: supplierIdValue,
        ...(latestSupplierQuoteId ? { supplierQuoteId: latestSupplierQuoteId } : {}),
        negotiable: Data?.negotiable || "Y",
        validityDate: validityDate
          ? dayjs(validityDate).toISOString()
          : dayjs().add(30, "days").toISOString(),
        paymentTerms: Data?.paymentTerms || "Credit",
        paymentDays: Data?.paymentDays ? Number(Data.paymentDays) : null,
        paymentPercentage: paymentPercentage ? Number(paymentPercentage) : null,
        status: "QUOTED",
        additionalChargesArray:
          additionalCharges?.map((charge: any) => {
            return {
              name: charge?.name || "",
              price: Number(charge?.price || 0),
            };
          }) || [],
        approvalRequired: approvalRequired || "N",
        signatureLabel: invoiceSignature?.label || "Authorised Signatory",
        supplierPreferredBrands:
          (() => {
            if (newPreferredBrandsArray.length > 0) {
              return buildSupplierPreferredBrandsPayload(newPreferredBrandsArray);
            }
            if (Data?.supplierPreferredBrands && Array.isArray(Data.supplierPreferredBrands) && Data.supplierPreferredBrands.length > 0) {
              if (typeof Data.supplierPreferredBrands[0] === "string") {
                return buildSupplierPreferredBrandsPayload(Data.supplierPreferredBrands);
              }
              return Data.supplierPreferredBrands;
            }
            if (newPreferredBrands) {
              try {
                const parsed = JSON.parse(newPreferredBrands);
                if (Array.isArray(parsed)) return parsed;
              } catch (e) {
                // If not JSON, treat as empty
              }
            }
            const originalValue = OriginalData?.supplierHeader?.supplierPreferredBrands;
            if (Array.isArray(originalValue)) {
              return originalValue;
            }
            return [];
          })(),
      };

      // Remove null/undefined supplierId if not available
      if (!header.supplierId) {
        delete header.supplierId;
      }

      if (invoiceSignature?.image) {
        const image = base64ToFile(invoiceSignature?.image, "signature.png");
        _formData.append("files", image);
        newfiledata.push({
          fileIndex: newfiledata.length,
          module: "quotations",
          moduleFileType: "signature",
          level: "HEADER_LEVEL",
          action: "Create",
        });
      }

      // Create payload with supplierHeader and supplierLines - will be sent as body string in FormData
      const payload: any = {
        filesData: {
          newfiledata: newfiledata,
          deletedFileData: deletedFileData,
        },
        supplierHeader: header,
        supplierLines: lines,
      };

      _formData.append("body", JSON.stringify(payload));

      // Send as FormData with files and body
      const response = await quotationApis.publicLinkQuote(_formData);

      const { status, message, response: apiResponse } = response;
      if (status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            mode === "edit"
              ? "Quotation Updated Successfully"
              : "Quoted Successfully",
        });
        closeDrawer();

        // Reset showSubmitBtm to false when switching to view mode after successful creation
        setShowSubmitBtm(false);

        // After successful submission, fetch quotation data to determine view/create mode based on isQuoted
        // Get supplierQuoteId from response and store it
        const newSupplierQuoteId =
          apiResponse?.data?.supplierQuoteId || apiResponse?.supplierQuoteId;
        if (newSupplierQuoteId) {
          setSubmittedSupplierQuoteId(newSupplierQuoteId);
        }
        // Fetch quotation data using quotationId - this will set view mode based on isQuoted value
        fetchOrderDetails();

        if (onSuccess) {
          onSuccess();
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: message,
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.log(error);
    }
    setDisableSubmit(false);
    setDisableCreateQuoteSubmit(false);
  };

  function base64ToFile(base64String: string, fileName: string) {
    const byteString = atob(base64String.split(",")[1]);
    const mimeString = base64String.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: mimeString });
    return new File([blob], fileName, { type: mimeString });
  }

  const fetchHtmlContentFromUrl = async (url: string) => {
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "text/html",
        },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const ShowAddressPopOver = ({ address }: any) => {
    return (
      <ul>
        <li>{address.addressLine1}</li>
        <li>{address.addressLine2}</li>
        <li>
          {address.city}, {address.stateName}, {address.countryName} -{" "}
          {address.pincode}
        </li>
      </ul>
    );
  };

  const handlePaymentTermChange = (value: string) => {
    setPaymentTerm(value);
  };

  // View mode inline editing functions
  const editViewMode = (record: any) => {
    // Use column dataIndex names for form fields (supplyQuantity, minPurchaseQuantity)
    form.setFieldsValue({
      supplyQuantity: Number(record.supplyQuantity || record.suppliedQty),
      minPurchaseQuantity: Number(record.minPurchaseQuantity || record.minQty),
      suppliedQty: Number(record.suppliedQty || record.supplyQuantity), // Also set for compatibility
      minQty: Number(record.minQty || record.minPurchaseQuantity), // Also set for compatibility
      hsn: record.hsn,
      price: Number(record.price),
      sgst: Number(record.sgst || record.sgstData),
      cgst: Number(record.cgst || record.cgstData),
      igst: Number(record.igst || record.igstData),
      leadDays: Number(record.leadDays),
      sellingPrice: record.sellingPrice
        ? Number(record.sellingPrice)
        : undefined,
      discount: record.discount ? Number(record.discount) : undefined,
      ...record,
    });
    setEditingKey(record.quotationLineId || record.id);
  };

  const saveViewMode = async (key: React.Key) => {
    try {
      const row: any = await form.validateFields();
      const newData: any = [...data];
      const index = newData.findIndex(
        (item: any) => key == (item.quotationLineId || item.id)
      );

      if (index > -1) {
        const item = newData[index];
        // Read from form fields - check both field name variants (column dataIndex and alternative names)
        const quantityInvoiced =
          row.supplyQuantity !== null &&
            row.supplyQuantity !== undefined &&
            row.supplyQuantity !== ""
            ? Number(row.supplyQuantity)
            : row.suppliedQty !== null &&
              row.suppliedQty !== undefined &&
              row.suppliedQty !== ""
              ? Number(row.suppliedQty)
              : 0;
        const minQtyValue =
          row.minPurchaseQuantity !== null &&
            row.minPurchaseQuantity !== undefined &&
            row.minPurchaseQuantity !== ""
            ? Number(row.minPurchaseQuantity)
            : row.minQty !== null &&
              row.minQty !== undefined &&
              row.minQty !== ""
              ? Number(row.minQty)
              : 0;
        // Calculate price from sellingPrice and discount if pricingMode is MRP
        let calculatedPrice: number = 0;
        if (
          pricingMode === "MRP" &&
          row?.sellingPrice &&
          row?.discount !== undefined
        ) {
          const sellingPrice = Number(row.sellingPrice);
          const discount = Number(row.discount);
          calculatedPrice = sellingPrice - (discount * sellingPrice) / 100;
        } else {
          calculatedPrice =
            row.price !== null && row.price !== undefined && row.price !== ""
              ? Number(row.price)
              : 0;
        }

        const unitPrice = calculatedPrice;
        const basicAmount = quantityInvoiced * unitPrice;
        // Read SGST/CGST/IGST as percentage values from form (user input)
        // Only read from form row, don't fallback to item to prevent multiplication
        // Ensure values are parsed correctly as numbers (not strings that might be formatted)
        const sgst =
          row.sgst !== null && row.sgst !== undefined && row.sgst !== ""
            ? typeof row.sgst === "string"
              ? parseFloat(row.sgst.replace(/[^\d.]/g, ""))
              : Number(row.sgst)
            : 0;
        const igst =
          row.igst !== null && row.igst !== undefined && row.igst !== ""
            ? typeof row.igst === "string"
              ? parseFloat(row.igst.replace(/[^\d.]/g, ""))
              : Number(row.igst)
            : 0;
        const cgst =
          row.cgst !== null && row.cgst !== undefined && row.cgst !== ""
            ? typeof row.cgst === "string"
              ? parseFloat(row.cgst.replace(/[^\d.]/g, ""))
              : Number(row.cgst)
            : 0;

        // Validate that values are reasonable percentages (0-100)
        if (isNaN(sgst) || sgst > 100 || sgst < 0) {
          console.warn("Invalid SGST value:", row.sgst, "->", sgst);
        }
        if (isNaN(cgst) || cgst > 100 || cgst < 0) {
          console.warn("Invalid CGST value:", row.cgst, "->", cgst);
        }
        if (isNaN(igst) || igst > 100 || igst < 0) {
          console.warn("Invalid IGST value:", row.igst, "->", igst);
        }
        const leadDaysValue =
          row.leadDays !== null &&
            row.leadDays !== undefined &&
            row.leadDays !== ""
            ? Number(row.leadDays)
            : 0;

        // Calculate tax amounts from percentage values
        const sgstData = (basicAmount * sgst) / 100;
        const igstData = (basicAmount * igst) / 100;
        const cgstData = (basicAmount * cgst) / 100;

        const lineTotal = basicAmount + sgstData + igstData + cgstData;

        // GST Type logic: if CGST/SGST values exist, clear IGST; if IGST exists, clear CGST/SGST
        let finalCgst = cgst;
        let finalSgst = sgst;
        let finalIgst = igst;
        let finalCgstData = cgstData;
        let finalSgstData = sgstData;
        let finalIgstData = igstData;

        if (igst > 0) {
          // If IGST is entered, clear CGST and SGST
          finalCgst = 0;
          finalSgst = 0;
          finalCgstData = 0;
          finalSgstData = 0;
        } else if (cgst > 0 || sgst > 0) {
          // If CGST or SGST is entered, clear IGST
          finalIgst = 0;
          finalIgstData = 0;
        }

        const updatedRow: any = {
          ...item,
          suppliedQty: quantityInvoiced,
          minQty: minQtyValue,
          minPurchaseQuantity: minQtyValue,
          supplyQuantity: quantityInvoiced,
          hsn: row.hsn || item.hsn || "",
          price: unitPrice,
          // Store percentage values (same as API structure)
          sgst: finalSgst,
          cgst: finalCgst,
          igst: finalIgst,
          // Store calculated amounts
          sgstData: finalSgstData,
          cgstData: finalCgstData,
          igstData: finalIgstData,
          basicAmount: basicAmount,
          leadDays: leadDaysValue,
          lineTotal:
            basicAmount + finalSgstData + finalCgstData + finalIgstData || 0,
        };

        // Add sellingPrice and discount if pricingMode is MRP
        if (pricingMode === "MRP") {
          if (row.sellingPrice !== undefined) {
            updatedRow.sellingPrice = Number(row.sellingPrice);
          }
          if (row.discount !== undefined) {
            updatedRow.discount = Number(row.discount);
          }
        }

        newData.splice(index, 1, updatedRow);
        setData(newData);
        setFilterData(newData);

        // Update invoiceableLines for totals calculation
        const lineExists = invoiceableLines.some(
          (line: any) => line.quotationLineId === key || line.id === key
        );

        if (lineExists) {
          // Update existing line
          const updatedInvoiceLines = invoiceableLines.map((line: any) => {
            if (line.quotationLineId === key || line.id === key) {
              const updatedLine = {
                ...line,
                ...updatedRow,
                supplyQuantity: quantityInvoiced, // Ensure supplyQuantity is set for table display
                minPurchaseQuantity: minQtyValue, // Ensure minPurchaseQuantity is set for table display
                suppliedQty: quantityInvoiced, // Also set suppliedQty for consistency
                minQty: minQtyValue, // Also set minQty for consistency
                basicAmount,
                // Store percentage values (same as API structure)
                sgst: finalSgst,
                igst: finalIgst,
                cgst: finalCgst,
                // Store calculated amounts
                sgstData: finalSgstData,
                igstData: finalIgstData,
                cgstData: finalCgstData,
                grossTotal:
                  basicAmount + finalSgstData + finalCgstData + finalIgstData,
              };
              return updatedLine;
            }
            return line;
          });
          setInvoiceableLines(updatedInvoiceLines);
        } else {
          // Add new line to invoiceableLines if it doesn't exist
          const newLine = {
            ...updatedRow,
            quotationLineId: key,
            id: key,
            supplyQuantity: quantityInvoiced,
            minPurchaseQuantity: minQtyValue,
            suppliedQty: quantityInvoiced,
            minQty: minQtyValue,
            basicAmount,
            sgst: finalSgst,
            igst: finalIgst,
            cgst: finalCgst,
            sgstData: finalSgstData,
            igstData: finalIgstData,
            cgstData: finalCgstData,
            grossTotal:
              basicAmount + finalSgstData + finalCgstData + finalIgstData,
          };
          setInvoiceableLines([...invoiceableLines, newLine]);
        }

        // Clear form fields after saving
        form.resetFields();
        setEditingKey(null);
        setShowSubmitBtm(true);
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const cancelViewMode = () => {
    setEditingKey(null);
    form.resetFields();
  };

  const submitViewModeChanges = async () => {
    try {
      // Validate that required data exists
      if (
        !OriginalData?.supplierHeader &&
        !OriginalData?.quotationInfo?.quotationHeader
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Quotation data not found. Please refresh the page.",
        });
        setDisableSubmit(false);
        return;
      }

      const quotationId =
        OriginalData?.supplierHeader?.quotationId ||
        OriginalData?.quotationInfo?.quotationHeader?.quotationId;

      if (!quotationId) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Quotation ID not found. Please refresh the page.",
        });
        setDisableSubmit(false);
        return;
      }

      const _formData = new FormData();
      const deletedFileData: any[] = [];
      const newfiledata: any[] = [];

      // Handle deleted attachments
      deletedAttachments.forEach((deletedFile: any) => {
        deletedFileData.push({
          docId: deletedFile.docId,
          moduleFileType: deletedFile.moduleFileType || "attachments",
          ...(deletedFile.supplierDocQuoteId && {
            supplierDocQuoteId: deletedFile.supplierDocQuoteId,
          }),
        });
      });

      // Handle new attachments
      newAttachments.forEach((attachment: any) => {
        if (attachment.file) {
          _formData.append("files", attachment.file);
          newfiledata.push({
            fileIndex: newfiledata.length,
            module: "Quotations",
            moduleFileType: "attachments",
            level: "HEADER_LEVEL",
          });
        }
      });

      // Handle updated Terms and Conditions
      if (isSupplierTermsChanged) {
        // Get the actual terms value - check form value, state, and supplierTermsAndConditions
        const formValue = methods.getValues("supplierTermsAndConditions");
        const stateValue = newSupplierTermsAndConditions;
        const supplierTermsValue = supplierTermsAndConditions;

        // Priority: form value > newSupplierTermsAndConditions > supplierTermsAndConditions > empty
        let termsValue = "";
        if (formValue !== undefined && formValue !== null) {
          const formStr = String(formValue).trim();
          if (formStr !== "") {
            termsValue = formStr;
          }
        }

        if (!termsValue && stateValue !== undefined && stateValue !== null) {
          const stateStr = String(stateValue).trim();
          if (stateStr !== "") {
            termsValue = stateStr;
          }
        }

        if (
          !termsValue &&
          supplierTermsValue !== undefined &&
          supplierTermsValue !== null
        ) {
          const supplierStr = String(supplierTermsValue).trim();
          if (supplierStr !== "") {
            termsValue = supplierStr;
          }
        }

        // Check if terms are empty (after trimming)
        const isTermsEmpty = !termsValue || termsValue.trim() === "";

        if (isTermsEmpty) {
          // Terms were cleared - delete old terms if they exist
          if (originalSupplierTermsDocId) {
            deletedFileData.push({
              docId: originalSupplierTermsDocId,
              moduleFileType: "termsAndConditions",
            });
          } else {
            // If no original document exists but terms were cleared,
            // send an empty file to explicitly clear terms on the server
            const emptyTermsFile = new Blob([""], {
              type: "text/html",
            });
            _formData.append(
              "files",
              new File([emptyTermsFile], "termsAndConditions.html", {
                type: "text/html",
              })
            );
            newfiledata.push({
              fileIndex: newfiledata.length,
              module: "quotations",
              moduleFileType: "termsAndConditions",
              level: "HEADER_LEVEL",
            });
          }
        } else {
          // Terms were updated - add new file and delete old one
          const termsAndConditionsFile = new Blob([termsValue], {
            type: "text/html",
          });
          _formData.append(
            "files",
            new File([termsAndConditionsFile], "termsAndConditions.html", {
              type: "text/html",
            })
          );
          newfiledata.push({
            fileIndex: newfiledata.length,
            module: "quotations",
            moduleFileType: "termsAndConditions",
            level: "HEADER_LEVEL",
          });
          // Add old terms document to deletedFileData if it exists
          if (originalSupplierTermsDocId) {
            deletedFileData.push({
              docId: originalSupplierTermsDocId,
              moduleFileType: "termsAndConditions",
            });
          }
        }
      }

      // Handle Required Documents files
      // First, find deleted files by comparing original with current
      if (originalRequiredDOC && originalRequiredDOC.length > 0) {
        originalRequiredDOC.forEach((originalDoc: any) => {
          const currentDoc = requiredDOC.find(
            (d: any) => d.quotationDocNameId === originalDoc.quotationDocNameId
          );

          if (originalDoc.dms && originalDoc.dms.length > 0) {
            originalDoc.dms.forEach((originalFile: any) => {
              // Check if this file still exists in current doc
              const fileStillExists =
                currentDoc &&
                currentDoc.dms &&
                currentDoc.dms.some(
                  (f: any) =>
                    f.docId === originalFile.docId ||
                    (f.fileName === originalFile.fileName &&
                      f.filePath === originalFile.filePath &&
                      !f.isNew)
                );

              // If file was deleted (exists in original but not in current) and has docId
              if (!fileStillExists && originalFile.docId) {
                deletedFileData.push({
                  docId: originalFile.docId,
                  moduleFileType: "Supplier Docs",
                  ...(originalFile.supplierDocQuoteId && {
                    supplierDocQuoteId: originalFile.supplierDocQuoteId,
                  }),
                });
              }
            });
          }
        });
      }

      // Then, handle new files in Required Documents
      if (requiredDOC && requiredDOC.length > 0) {
        requiredDOC.forEach((doc: any) => {
          if (doc.dms && doc.dms.length > 0) {
            doc.dms.forEach((fileItem: any) => {
              // New files (isNew flag indicates newly uploaded)
              if (fileItem.isNew && fileItem.file) {
                _formData.append("files", fileItem.file);
                newfiledata.push({
                  quotationDocNameId: doc.quotationDocNameId,
                  fileIndex: newfiledata.length,
                  module: "Quotations",
                  moduleFileType: "Supplier Docs",
                  level: "LINE_LEVEL",
                  ...(doc.supplierDocQuoteId && {
                    supplierDocQuoteId: doc.supplierDocQuoteId,
                  }),
                });
              }
            });
          }
        });
      }

      // Use data state which has the latest saved values from view mode edits
      // Calculate totals for lines
      const updatedLines = data.map((item: any) => {
        // Get actual values - check multiple possible field names
        // Priority: suppliedQty > supplyQuantity, minQty > minPurchaseQuantity
        const suppliedQtyValue =
          item.suppliedQty !== null &&
            item.suppliedQty !== undefined &&
            item.suppliedQty !== ""
            ? Number(item.suppliedQty)
            : item.supplyQuantity !== null &&
              item.supplyQuantity !== undefined &&
              item.supplyQuantity !== ""
              ? Number(item.supplyQuantity)
              : 0;

        const minQtyValue =
          item.minQty !== null &&
            item.minQty !== undefined &&
            item.minQty !== ""
            ? Number(item.minQty)
            : item.minPurchaseQuantity !== null &&
              item.minPurchaseQuantity !== undefined &&
              item.minPurchaseQuantity !== ""
              ? Number(item.minPurchaseQuantity)
              : 0;

        // Calculate price from sellingPrice and discount if pricingMode is MRP
        let priceValue: number = 0;
        if (
          pricingMode === "MRP" &&
          item?.sellingPrice &&
          item?.discount !== undefined
        ) {
          const sellingPrice = Number(item.sellingPrice);
          const discount = Number(item.discount);
          priceValue = sellingPrice - (discount * sellingPrice) / 100;
        } else {
          priceValue =
            item.price !== null && item.price !== undefined && item.price !== ""
              ? Number(item.price)
              : 0;
        }

        // Read percentage values only (not calculated amounts)
        const cgstValue =
          item.cgst !== null && item.cgst !== undefined && item.cgst !== ""
            ? Number(item.cgst)
            : 0;

        const sgstValue =
          item.sgst !== null && item.sgst !== undefined && item.sgst !== ""
            ? Number(item.sgst)
            : 0;

        const igstValue =
          item.igst !== null && item.igst !== undefined && item.igst !== ""
            ? Number(item.igst)
            : 0;

        const leadDaysValue =
          item.leadDays !== null &&
            item.leadDays !== undefined &&
            item.leadDays !== ""
            ? Number(item.leadDays)
            : 0;

        const lineTotal =
          Number(priceValue || 0) * Number(suppliedQtyValue || 0);

        // Apply GST Type logic: if IGST exists, CGST and SGST should be 0; if CGST+SGST exists, IGST should be 0
        let finalCgstValue = cgstValue;
        let finalSgstValue = sgstValue;
        let finalIgstValue = igstValue;

        if (igstValue > 0) {
          // If IGST exists, clear CGST and SGST
          finalCgstValue = 0;
          finalSgstValue = 0;
        } else if (cgstValue > 0 || sgstValue > 0) {
          // If CGST or SGST exists, clear IGST
          finalIgstValue = 0;
        }

        const cgstAmt = (lineTotal * Number(finalCgstValue || 0)) / 100;
        const sgstAmt = (lineTotal * Number(finalSgstValue || 0)) / 100;
        const igstAmt = (lineTotal * Number(finalIgstValue || 0)) / 100;
        const lineTotalWithTax = lineTotal + cgstAmt + sgstAmt + igstAmt;

        // Get latest supplierQuoteId from API - prefer OriginalData (from fetchPublicLinkQuotationResponse)
        const lineSupplierQuoteId =
          item.supplierQuoteId ||
          OriginalData?.supplierHeader?.supplierQuoteId ||
          submittedSupplierQuoteId ||
          OriginalData?.quotationInfo?.quotationHeader?.supplierQuoteId ||
          null;

        return {
          id: item.supplierQuoteLineId || item.id || null,
          supplierQuoteId: lineSupplierQuoteId,
          quotationLineId: item.quotationLineId || item.id,
          quotationId: quotationId,
          rfqId:
            OriginalData?.supplierHeader?.rfqId ||
            OriginalData?.quotationInfo?.quotationHeader?.rfqId,
          version:
            OriginalData?.supplierHeader?.version ||
            OriginalData?.quotationInfo?.quotationHeader?.version ||
            1,
          latest:
            OriginalData?.supplierHeader?.latest ||
            OriginalData?.quotationInfo?.quotationHeader?.latest ||
            1,
          minQty: Number(minQtyValue || 0),
          suppliedQty: Number(suppliedQtyValue || 0),
          supplyQuantity: Number(suppliedQtyValue || 0),
          minPurchaseQuantity: Number(minQtyValue || 0),
          hsn: item.hsn || "",
          price: Number(priceValue || 0),
          cgst: Number(finalCgstValue || 0),
          sgst: Number(finalSgstValue || 0),
          igst: Number(finalIgstValue || 0),
          cgstAmt: Number(cgstAmt.toFixed(2)),
          sgstAmt: Number(sgstAmt.toFixed(2)),
          igstAmt: Number(igstAmt.toFixed(2)),
          leadDays: Number(leadDaysValue || 0),
          lineTotal: Number(lineTotalWithTax.toFixed(2)),
          ...(pricingMode === "MRP" && {
            sellingPrice: item.sellingPrice
              ? Number(item.sellingPrice)
              : undefined,
            discount:
              item.discount !== undefined ? Number(item.discount) : undefined,
          }),
        };
      });

      // Calculate totals for header
      let totalNetAmount = 0,
        cgst = 0,
        sgst = 0,
        igst = 0;

      updatedLines.forEach((line: any) => {
        const lineTotal = Number(line.price) * Number(line.suppliedQty);
        totalNetAmount += lineTotal;
        cgst += (lineTotal * line.cgst) / 100;
        sgst += (lineTotal * line.sgst) / 100;
        igst += (lineTotal * line.igst) / 100;
      });

      const totalAdditionalCharges =
        additionalCharges?.reduce(
          (sum: number, charge: any) => sum + (Number(charge?.price) || 0),
          0
        ) || 0;

      // Get supplierId from OriginalData
      const supplierIdValue =
        OriginalData?.supplierHeader?.referencedSupplierId ||
        OriginalData?.supplierHeader?.supplierId ||
        null;

      // Calculate gross total
      const grossTotal =
        totalNetAmount + cgst + sgst + igst + totalAdditionalCharges;

      // Get latest supplierQuoteId from API (fetchPublicLinkQuotationResponse) - always prefer latest
      const headerSupplierQuoteId =
        OriginalData?.supplierHeader?.supplierQuoteId ||
        submittedSupplierQuoteId ||
        OriginalData?.quotationInfo?.quotationHeader?.supplierQuoteId ||
        updatedLines[0]?.supplierQuoteId ||
        null;

      // Update header with new values - include all required fields
      const updatedHeader: any = {
        supplierQuoteId: headerSupplierQuoteId,
        quotationId: quotationId,
        pricingMode: OriginalData?.supplierHeader?.pricingMode || "Base Price",
        rfqId:
          OriginalData?.supplierHeader?.rfqId ||
          OriginalData?.quotationInfo?.quotationHeader?.rfqId,
        orgId:
          OriginalData?.supplierHeader?.orgId ||
          OriginalData?.quotationInfo?.quotationHeader?.orgId ||
          null,
        ...(supplierIdValue ? { supplierId: supplierIdValue } : {}),
        version: OriginalData?.supplierHeader?.version || 1,
        negotiable:
          newNegotiableType || OriginalData?.supplierHeader?.negotiable || "Y",
        validityDate: newValidityDate
          ? dayjs(newValidityDate).format("YYYY-MM-DD")
          : OriginalData?.supplierHeader?.validityDate
            ? dayjs(OriginalData.supplierHeader.validityDate).format("YYYY-MM-DD")
            : dayjs().add(30, "days").format("YYYY-MM-DD"),
        paymentTerms:
          OriginalData?.supplierHeader?.paymentTerms ||
          OriginalData?.quotationInfo?.quotationHeader?.paymentTerms ||
          "Credit",
        paymentDays: newPaymentDays
          ? String(newPaymentDays)
          : OriginalData?.supplierHeader?.paymentDays
            ? String(OriginalData.supplierHeader.paymentDays)
            : null,
        paymentPercentage: OriginalData?.supplierHeader?.paymentPercentage
          ? Number(OriginalData.supplierHeader.paymentPercentage)
          : null,
        status: "QUOTED",
        netTotal: totalNetAmount.toFixed(6),
        totalAdditionalCharges: totalAdditionalCharges.toFixed(6),
        additionalChargesArray:
          additionalCharges?.map((charge: any) => ({
            name: charge?.name || "",
            price: Number(charge?.price || 0),
          })) || [],
        supplierPreferredBrands:
          (() => {
            if (newPreferredBrandsArray.length > 0) {
              return buildSupplierPreferredBrandsPayload(newPreferredBrandsArray);
            }
            if (newPreferredBrands) {
              try {
                const parsed = JSON.parse(newPreferredBrands);
                if (Array.isArray(parsed)) return parsed;
              } catch (e) {
                // If not JSON, treat as empty
              }
            }
            const originalValue = OriginalData?.supplierHeader?.supplierPreferredBrands;
            if (Array.isArray(originalValue)) {
              return originalValue;
            }
            return [];
          })(),
        cgst: cgst.toFixed(6),
        sgst: sgst.toFixed(6),
        igst: igst.toFixed(6),
        gross: grossTotal.toFixed(6),
        createdBy:
          OriginalData?.supplierHeader?.createdBy || userInfo?.userId || null,
        createdAt:
          OriginalData?.supplierHeader?.createdAt || new Date().toISOString(),
        tncChecked: OriginalData?.supplierHeader?.tncChecked || false,
        approvalRequired: OriginalData?.supplierHeader?.approvalRequired || "N",
        signatureLabel:
          OriginalData?.supplierHeader?.signatureLabel ||
          "Authorised Signatory",
      };

      // Create payload with supplierHeader and supplierLines - will be sent as body string in FormData
      const payload = {
        filesData: {
          newfiledata: newfiledata,
          deletedFileData: deletedFileData,
          updatedFileData: [],
        },
        supplierHeader: updatedHeader,
        supplierLines: updatedLines,
      };

      _formData.append("body", JSON.stringify(payload));

      // Always send API call for update
      // Send as FormData with files and body
      const response: any = await quotationApis.publicLinkQuote(_formData);

      const status = response?.status;
      const message = response?.message;
      if (status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Quotation Updated Successfully",
        });
        setShowSubmitBtm(false);
        setDisableSubmit(false);
        setNewNegotiableType("");
        setNewValidityDate(undefined);
        setNewPaymentDays("");
        setNewPreferredBrands("");
        setNewPreferredBrandsArray([]);
        // Reset file tracking states
        setDeletedAttachments([]);
        setNewAttachments([]);
        setIsSupplierTermsChanged(false);
        // Update originalRequiredDOC to current state after successful update
        setOriginalRequiredDOC(JSON.parse(JSON.stringify(requiredDOC)));
        // Refresh data after successful update
        fetchOrderDetails();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: message || "Failed to update quotation",
        });
        setDisableSubmit(false);
      }
    } catch (error: any) {
      console.error("Error in submitViewModeChanges:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to update quotation. Please try again.",
      });
      setDisableSubmit(false);
    }
  };

  return isLoading == true ? (
    <>
      <Flex align="center" gap="middle" className="pageLoader">
        <Spin size="large" />
      </Flex>
    </>
  ) : (
    <>
      {contextHolder}
      <Head title="Fill Quotation" />
      <Content>
        <Card className="card-bordered">
          <div className="card-inner card-inner-lg">
            <BlockHead size="lg">
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle tag="h4">
                    <span>
                      RFQ -{" "}
                      {OriginalData?.quotationInfo?.quotationHeader?.rfqId ||
                        OriginalData?.supplierHeader?.rfqId ||
                        "RFQ-2024-001"}
                      {mode === "edit" && " (Edit Mode)"}
                    </span>
                  </BlockTitle>
                </BlockHeadContent>

                <div className="d-flex">
                  {showSubmitBtm && (
                    <div className="actions clearfix">
                      <ul
                        className="m-auto d-flex align-items-center justify-content-center p-0"
                        style={{
                          flexDirection: "row-reverse",
                        }}
                      >
                        <li className="pt-0 pb-0">
                          {disableSubmit ? (
                            <Button color="primary" type="button">
                              <Spinner size="sm" color="light" />
                            </Button>
                          ) : (
                            <Button
                              color="primary"
                              type="button"
                              onClick={async () => {
                                setDisableSubmit(true);
                                Swal.fire({
                                  title: "Are you sure?",
                                  text: "Do you want to submit the changes?",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#3085d6",
                                  cancelButtonColor: "#d33",
                                  confirmButtonText: "Yes, submit it!",
                                  cancelButtonText: "No, cancel",
                                }).then(async (result) => {
                                  if (result.isConfirmed) {
                                    if (viewMode) {
                                      await submitViewModeChanges();
                                    } else {
                                      // For create/edit mode, show drawer for final submission
                                      try {
                                        await form.validateFields();
                                        if (areAllRowsFilled()) {
                                          showDrawer();
                                        } else {
                                          message.error(
                                            "Please fill out all required fields."
                                          );
                                          setDisableSubmit(false);
                                        }
                                      } catch (errorInfo) {
                                        message.error(
                                          "Validation failed: Please fill out all required fields."
                                        );
                                        setDisableSubmit(false);
                                      }
                                    }
                                  } else {
                                    setDisableSubmit(false);
                                  }
                                });
                              }}
                            >
                              Submit
                            </Button>
                          )}
                        </li>
                        <li className="pt-0 pb-0">
                          <Button
                            color="secondary"
                            onClick={() => {
                              Swal.fire({
                                title: "Are you sure?",
                                text: "Do you want to revert the changes?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes, revert it!",
                                cancelButtonText: "No, cancel",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  if (viewMode) {
                                    fetchOrderDetails();
                                  } else {
                                    // Reset form and data
                                    form.resetFields();
                                    setSelectedRowKeys([]);
                                    setEditingKeys([]);
                                    setEditingKey(null);
                                    setNewNegotiableType("");
                                    setNewValidityDate(undefined);
                                    setNewPaymentDays("");
                                    setNewPreferredBrands("");
                                    setNewPreferredBrandsArray([]);
                                    fetchOrderDetails();
                                  }
                                  setShowSubmitBtm(false);
                                  Swal.fire(
                                    "Reverted!",
                                    "Your changes have been reverted.",
                                    "success"
                                  );
                                }
                              });
                            }}
                            type="button"
                            className="btn-dim btn btn-secondary"
                          >
                            Revert
                          </Button>
                        </li>
                      </ul>
                    </div>
                  )}
                  {!showSubmitBtm && (
                    <div className="actions clearfix">
                      <ul
                        className="m-auto d-flex align-items-center justify-content-center p-0"
                        style={{
                          flexDirection: "row-reverse",
                        }}
                      >
                        <li className="pt-0 pb-0">
                          {onBack && (
                            <Button
                              className="toggle"
                              color="primary"
                              onClick={onBack}
                            >
                              <Icon name="arrow-left" />
                              <span>Back</span>
                            </Button>
                          )}
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </BlockBetween>
            </BlockHead>
            <div className="content clearfix">
              <AntCollapse
                defaultActiveKey={
                  viewMode ? ["1", "2", "3", "4"] : ["1", "2", "3"]
                }
              >
                <Panel header="General Details" key="1">
                  <Descriptions
                    title=""
                    className="custom-description-title"
                    column={{ xxl: 3, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }}
                  >
                    <Descriptions.Item label="Quotation For">
                      Material
                    </Descriptions.Item>
                    <Descriptions.Item label="Customer">
                      {OriginalData?.quotationInfo?.quotationHeader?.orgName ||
                        "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Site Name">
                      {OriginalData?.quotationInfo?.quotationHeader?.siteName ||
                        "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Pricing Mode">
                      {pricingMode || "Base Price"}
                    </Descriptions.Item>
                    {isQuoted && (
                      <Descriptions.Item label="Negotiable">
                        {viewMode && OriginalData?.supplierHeader ? (
                          <Form.Item
                            name="negotiable"
                            label={undefined}
                            className="w-50 p-0 m-0"
                            initialValue={
                              OriginalData?.supplierHeader?.negotiable
                            }
                          >
                            <Select
                              placeholder="Select Negotiable Type"
                              defaultValue={
                                OriginalData?.supplierHeader?.negotiable
                              }
                              onChange={(e) => {
                                setNewNegotiableType(e);
                                setShowSubmitBtm(true);
                              }}
                            >
                              <Option value="Y">Yes</Option>
                              <Option value="N">No</Option>
                            </Select>
                          </Form.Item>
                        ) : OriginalData?.supplierHeader?.negotiable === "Y" ? (
                          "Yes"
                        ) : (
                          "No"
                        )}
                      </Descriptions.Item>
                    )}
                    <Descriptions.Item label="Credit Days">
                      {OriginalData?.quotationInfo?.quotationHeader
                        ?.expectedCreditDays || "--"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Delivery Address">
                      <a
                        href="#"
                        style={{
                          color: "#2263b3",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {OriginalData?.quotationInfo?.quotationHeader
                          ?.deliveryAddressName?.deliveryLocationName ||
                          OriginalData?.quotationInfo?.quotationHeader
                            ?.deliveryAddressName?.city ||
                          "N/A"}
                      </a>
                    </Descriptions.Item>
                    <Descriptions.Item label="Description">
                      {OriginalData?.quotationInfo?.quotationHeader
                        ?.quotationDescription || "Block 1, Gachibowli"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Additional Charges">
                      {OriginalData?.quotationInfo?.quotationHeader
                        ?.additionalCharges || "Variable"}
                    </Descriptions.Item>
                    {isQuoted && (
                      <Descriptions.Item
                        label="Validity Date"
                        labelStyle={{ verticalAlign: "top", minWidth: "160px" }}
                        contentStyle={{ verticalAlign: "top" }}
                      >
                        {viewMode && OriginalData?.supplierHeader ? (
                          <Form.Item
                            name="validityDate"
                            label={undefined}
                            className="w-50 p-0 m-0"
                            initialValue={
                              OriginalData?.supplierHeader?.validityDate
                            }
                          >
                            <DatePicker
                              className="w-100"
                              placeholder="Validity Date"
                              minDate={dayjs().add(0, "day")}
                              allowClear={false}
                              defaultValue={dayjs(
                                OriginalData?.supplierHeader?.validityDate
                              )}
                              onChange={(e) => {
                                setNewValidityDate(e);
                                setShowSubmitBtm(true);
                              }}
                            />
                          </Form.Item>
                        ) : OriginalData?.supplierHeader?.validityDate ? (
                          dayjs(
                            OriginalData.supplierHeader.validityDate
                          ).format("YYYY-MM-DD")
                        ) : (
                          "--"
                        )}
                      </Descriptions.Item>
                    )}
                    {isQuoted &&
                      OriginalData?.quotationInfo?.quotationHeader
                        ?.paymentTerms === "Credit" && (
                        <Descriptions.Item label="Supplier Credit Days">
                          {viewMode && OriginalData?.supplierHeader ? (
                            <Form.Item
                              name="paymentDays"
                              className="w-50 p-0 m-0"
                              initialValue={
                                OriginalData?.supplierHeader?.paymentDays
                              }
                            >
                              <Input
                                className="w-100"
                                type="number"
                                defaultValue={
                                  OriginalData?.supplierHeader?.paymentDays
                                }
                                placeholder="Enter Supplier Credit Days"
                                onChange={(e) => {
                                  setNewPaymentDays(e.target.value);
                                  setShowSubmitBtm(true);
                                }}
                              />
                            </Form.Item>
                          ) : (
                            OriginalData?.supplierHeader?.paymentDays || "--"
                          )}
                        </Descriptions.Item>
                      )}
                    <Descriptions.Item
                      label="Preferred Brands / Make"
                      labelStyle={{ verticalAlign: "top", minWidth: "160px" }}
                      contentStyle={{ verticalAlign: "top" }}
                    >
                      {viewMode && OriginalData?.supplierHeader ? (
                        <div className="w-100" style={{ minWidth: "280px", maxWidth: "100%" }}>
                          <Select
                            mode="tags"
                            style={{ width: "100%", minWidth: "280px", minHeight: "38px" }}
                            placeholder="Select or type to add brands"
                            value={newPreferredBrandsArray || []}
                            onChange={(val: string[]) =>
                              handlePreferredBrandsChange(val, true)
                            }
                            options={brandOptions}
                            tokenSeparators={[","]}
                            filterOption={(input, option) => {
                              const label = option?.label?.toString()?.toLowerCase() || "";
                              const val = option?.value?.toString()?.toLowerCase() || "";
                              return label.includes(input.toLowerCase()) || val.includes(input.toLowerCase());
                            }}
                            maxTagCount="responsive"
                            dropdownRender={(menu) => (
                              <>
                                {newPreferredBrandsArray?.length === brandOptions?.length ? (
                                  <>
                                    <a className="addNewItem" onClick={() => handlePreferredBrandsChange([], true)}>Clear All</a>
                                    <hr />
                                  </>
                                ) : (
                                  <>
                                    {brandOptions?.length > 6 && (
                                      <a className="addNewItem" onClick={() => handlePreferredBrandsChange(brandOptions.map((o) => o.value), true)}>Select All</a>
                                    )}
                                    <hr />
                                  </>
                                )}
                                <div className="drop-down-multiselect">{menu}</div>
                              </>
                            )}
                          />
                        </div>
                      ) : (
                        (() => {
                          const preferredBrandsValue = OriginalData?.supplierHeader?.supplierPreferredBrands ||
                            OriginalData?.quotationInfo?.quotationHeader?.preferredBrands;
                          if (Array.isArray(preferredBrandsValue) && preferredBrandsValue.length > 0) {
                            return preferredBrandsValue.map((brand: any) => 
                              typeof brand === "object" ? brand.brandName : brand
                            ).join(", ");
                          }
                          return preferredBrandsValue || "NA";
                        })()
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Last Submission Date"
                      labelStyle={{ verticalAlign: "top", minWidth: "160px" }}
                      contentStyle={{ verticalAlign: "top" }}
                    >
                      {OriginalData?.quotationInfo?.quotationHeader
                        ?.lastSubmissionDate ? (
                        <span className="badge-dim badge bg-primary rounded-pill">
                          <strong>
                            {dayjs(
                              OriginalData?.quotationInfo?.quotationHeader
                                ?.lastSubmissionDate
                            ).format("DD-MMM-YYYY")}
                          </strong>
                        </span>
                      ) : (
                        "--"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Submission Type">
                      {OriginalData?.quotationInfo?.quotationHeader
                        ?.deadlineType || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Payment Terms">
                      {OriginalData?.quotationInfo?.quotationHeader
                        ?.paymentTerms || "Credit"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Billing Address">
                      <a
                        href="#"
                        style={{
                          color: "#2263b3",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {OriginalData?.quotationInfo?.quotationHeader
                          ?.billingAddressName?.deliveryLocationName ||
                          OriginalData?.quotationInfo?.quotationHeader
                            ?.billingAddressName?.city ||
                          "N/A"}
                      </a>
                    </Descriptions.Item>
                  </Descriptions>
                </Panel>

                <Panel
                  header={viewMode ? "Materials" : "Material Information"}
                  key="2"
                >
                  <Form form={form} component={false}>
                    {/* GST Type Dropdown - only show in create mode, at the top like AddSupplierQuoteDrawer */}
                    {!viewMode && (
                      <>
                        <span ref={bulkUploadErrorsRef}></span>
                        <div
                          className="d-flex justify-content-between align-items-center m-0 p-0 mb-3"
                          style={{ padding: "0 15px" }}
                        >
                          <div className="w-70 d-flex align-items-center">
                            <strong className="ant-descriptions-item-content me-1">
                              GST Type
                            </strong>
                            <Form.Item
                              name="gstType"
                              label=""
                              className="mb-0 align-items-center"
                              style={{ width: 300 }}
                              rules={[{ required: true, message: "Required" }]}
                              initialValue="cgst+sgst"
                            >
                              <Select
                                value={gstType}
                                onChange={(value) => {
                                  setGstType(value);
                                  // Clear opposite GST fields for all rows
                                  if (value === "cgst+sgst") {
                                    // Clear IGST for all rows
                                    (data || []).forEach((row: any) => {
                                      form.setFieldsValue({
                                        [`igst_${row.rfqLineId}`]: null,
                                      });
                                    });
                                  } else if (value === "igst") {
                                    // Clear CGST and SGST for all rows
                                    (data || []).forEach((row: any) => {
                                      form.setFieldsValue({
                                        [`cgst_${row.rfqLineId}`]: null,
                                        [`sgst_${row.rfqLineId}`]: null,
                                      });
                                    });
                                  }
                                }}
                                allowClear={false}
                                placeholder="Select GST Type"
                                optionFilterProp="children"
                                defaultActiveFirstOption
                                filterOption={(input, option: any) =>
                                  (option?.label ?? "")
                                    ?.toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                <Select.Option value="cgst+sgst">
                                  CGST + SGST
                                </Select.Option>
                                <Select.Option value="igst">IGST</Select.Option>
                              </Select>
                            </Form.Item>
                          </div>
                          <BulkMaterialUpload
                            moduleKey={"quot-material-list"}
                            extra={{
                              igstFlag: gstType == "igst" ? 1 : 0,
                              quotationId: quotationId,
                              supplierId: userInfo?.supplierId
                                ? Number(userInfo.supplierId)
                                : undefined,
                            }}
                            append={(uploadedData: any) => {
                              console.clear();
                              const { errorFlag, lines } = uploadedData;
                              if (errorFlag) {
                                setUploadedDataErrors(lines);
                              } else {
                                setUploadedDataErrors([]);
                              }
                              const updatedRows: any = {};
                              lines?.forEach((row: any, index: any) => {
                                const {
                                  quotationLineId,
                                  rfqLineId,
                                  suppliedQty,
                                  supplyQuantity,
                                  minQty,
                                  minPurchaseQuantity,
                                  hsn,
                                  price,
                                  leadDays,
                                  sgst,
                                  cgst,
                                  igst,
                                  sellingPrice,
                                  discount,
                                  errorFlag,
                                } = row;
                                if (errorFlag) return;
                                let activeIndex: any = null;
                                const activeRecord = data.find(
                                  (item: any, index: any) => {
                                    const matchId =
                                      quotationLineId ||
                                      rfqLineId ||
                                      item.quotationLineId ||
                                      item.rfqLineId;
                                    if (
                                      matchId &&
                                      (matchId == item.quotationLineId ||
                                        matchId == item.rfqLineId)
                                    ) {
                                      activeIndex = index;
                                      return true;
                                    }
                                  }
                                );
                                if (activeIndex == null) return;

                                // Calculate price from sellingPrice and discount if MRP mode
                                let calculatedPrice: number | "N/A" = price
                                  ? Number(price)
                                  : "N/A";
                                if (
                                  pricingMode === "MRP" &&
                                  sellingPrice &&
                                  discount !== undefined
                                ) {
                                  const sp = Number(sellingPrice);
                                  const disc = Number(discount);
                                  calculatedPrice = sp - (disc * sp) / 100;
                                }

                                const quantityInvoiced =
                                  suppliedQty || supplyQuantity
                                    ? Number(suppliedQty || supplyQuantity)
                                    : "N/A";
                                const unitPrice: number | "N/A" =
                                  calculatedPrice !== "N/A"
                                    ? calculatedPrice
                                    : "N/A";
                                const basicAmount =
                                  quantityInvoiced !== "N/A" &&
                                  unitPrice !== "N/A"
                                    ? typeof quantityInvoiced === "number" &&
                                      typeof unitPrice === "number"
                                      ? quantityInvoiced * unitPrice
                                      : "N/A"
                                    : "N/A";

                                const sgstData =
                                  basicAmount !== "N/A" && sgst !== "N/A"
                                    ? (basicAmount * sgst) / 100
                                    : "N/A";
                                const igstData =
                                  basicAmount !== "N/A" && igst !== "N/A"
                                    ? (basicAmount * igst) / 100
                                    : "N/A";
                                const cgstData =
                                  basicAmount !== "N/A" && cgst !== "N/A"
                                    ? (basicAmount * cgst) / 100
                                    : "N/A";

                                const lineTotal =
                                  (basicAmount !== "N/A" ? basicAmount : 0) +
                                  (sgstData !== "N/A" ? sgstData : 0) +
                                  (igstData !== "N/A" ? igstData : 0) +
                                  (cgstData !== "N/A" ? cgstData : 0);

                                const lineId =
                                  activeRecord.rfqLineId ||
                                  activeRecord.quotationLineId;

                                const updatedRow: any = {
                                  ...activeRecord,
                                  quotationLineId:
                                    quotationLineId || activeRecord.quotationLineId,
                                  rfqLineId: rfqLineId || lineId,
                                  quantityInvoiced,
                                  unitPrice,
                                  basicAmount,
                                  sgst,
                                  igst,
                                  cgst,
                                  sgstData,
                                  igstData,
                                  cgstData,
                                  hsn,
                                  leadDays,
                                  minQty: minQty || minPurchaseQuantity,
                                  minPurchaseQuantity:
                                    minQty || minPurchaseQuantity,
                                  price:
                                    calculatedPrice !== "N/A"
                                      ? calculatedPrice
                                      : price,
                                  supplyQuantity:
                                    suppliedQty || supplyQuantity,
                                  suppliedQty: suppliedQty || supplyQuantity,
                                  grossTotal:
                                    basicAmount !== "N/A" &&
                                    sgst !== "N/A" &&
                                    igst !== "N/A" &&
                                    cgst !== "N/A"
                                      ? basicAmount + sgst + igst + cgst
                                      : "N/A",
                                  lineTotal,
                                };

                                // Add sellingPrice and discount if MRP mode
                                if (pricingMode === "MRP") {
                                  if (sellingPrice !== undefined) {
                                    updatedRow.sellingPrice = Number(sellingPrice);
                                  }
                                  if (discount !== undefined) {
                                    updatedRow.discount = Number(discount);
                                  }
                                }

                                // Update form values
                                form.setFieldsValue({
                                  [`supplyQuantity_${lineId}`]:
                                    suppliedQty || supplyQuantity,
                                  [`minPurchaseQuantity_${lineId}`]:
                                    minQty || minPurchaseQuantity,
                                  [`hsn_${lineId}`]: hsn,
                                  [`price_${lineId}`]:
                                    calculatedPrice !== "N/A"
                                      ? calculatedPrice
                                      : price,
                                  [`sgst_${lineId}`]: sgst,
                                  [`cgst_${lineId}`]: cgst,
                                  [`igst_${lineId}`]: igst,
                                  [`leadDays_${lineId}`]: leadDays,
                                  ...(pricingMode === "MRP" && {
                                    [`sellingPrice_${lineId}`]: sellingPrice,
                                    [`discount_${lineId}`]: discount,
                                  }),
                                });

                                updatedRows[lineId] = updatedRow;
                              });
                              setData((oldData: any) => {
                                return oldData?.map((oldDataRow: any) => {
                                  const lineId =
                                    oldDataRow?.rfqLineId ||
                                    oldDataRow?.quotationLineId;
                                  if (lineId && updatedRows[lineId]) {
                                    return updatedRows[lineId];
                                  }
                                  return oldDataRow;
                                });
                              });
                              setFilterData((oldData: any) => {
                                return oldData?.map((oldDataRow: any) => {
                                  const lineId =
                                    oldDataRow?.rfqLineId ||
                                    oldDataRow?.quotationLineId;
                                  if (lineId && updatedRows[lineId]) {
                                    return updatedRows[lineId];
                                  }
                                  return oldDataRow;
                                });
                              });
                            }}
                          />
                        </div>
                        <Alert
                          isOpen={uploadedDataErrors?.length > 0}
                          color="danger"
                          className="start-0 w-100 py-1 mt-2"
                          style={{
                            top: 0,
                            textAlign: "left",
                            fontSize: "14px",
                            cursor: "default",
                            margin: "0 15px",
                          }}
                        >
                          <Icon name={"info"} style={{ top: "0.6rem" }} />
                          <span>
                            Failed to prefill the data in the table due to an
                            issue with the inserted rows. You can{" "}
                            <Popconfirm
                              title={<></>}
                              icon={<></>}
                              showCancel={false}
                              open={uploadedDataErrorModal}
                              okButtonProps={{
                                style: {
                                  display: "none",
                                },
                              }}
                              onConfirm={() => {
                                try {
                                  console.log("confirm");
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              onCancel={() => {
                                alert("cancel");
                              }}
                              onOpenChange={(visible) => {
                                setUploadedDataErrorModal(visible);
                              }}
                              description={
                                <div
                                  style={{
                                    width: "60vw",
                                    height: "400px",
                                    overflow: "scroll",
                                  }}
                                >
                                  {uploadedDataErrors?.map(
                                    (row: any, index: any) => {
                                      const {
                                        errorMessage,
                                        materialName,
                                        materialId,
                                        errorFlag,
                                      } = row;
                                      if (errorFlag) {
                                        return (
                                          <Alert
                                            key={materialId + "_" + index}
                                            color="danger"
                                            className="start-0 w-100 py-1 mt-2"
                                            style={{
                                              top: 0,
                                              textAlign: "left",
                                              fontSize: "14px",
                                              cursor: "default",
                                              display: "flex",
                                            }}
                                          >
                                            <strong>
                                              {materialName} (Id: {materialId})
                                              &nbsp; &nbsp;
                                            </strong>
                                            <ol>
                                              {errorMessage?.map(
                                                (error: any) => (
                                                  <li>{error}</li>
                                                )
                                              )}
                                            </ol>
                                          </Alert>
                                        );
                                      }
                                      return (
                                        <Alert
                                          color="success"
                                          className="start-0 w-100 py-1 mt-2"
                                          style={{
                                            top: 0,
                                            textAlign: "left",
                                            fontSize: "14px",
                                            cursor: "default",
                                            display: "flex",
                                          }}
                                        >
                                          <strong>
                                            {materialName} (Id: {materialId}){" "}
                                            &nbsp; &nbsp;
                                          </strong>
                                          <ol>
                                            <li>This is a Valid record </li>
                                          </ol>
                                        </Alert>
                                      );
                                    }
                                  )}
                                </div>
                              }
                            >
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  bulkUploadErrorsRef?.current?.scrollIntoView({
                                    behavior: "smooth",
                                  });
                                  setUploadedDataErrorModal(true);
                                }}
                                target="_self"
                                style={{ textDecoration: "underline" }}
                              >
                                <strong>view the details</strong>
                              </a>
                            </Popconfirm>{" "}
                            , update the file and reupload it.
                          </span>
                        </Alert>
                        <div
                          className="d-flex justify-content-between align-items-center mt-1 mb-2"
                          style={{ padding: "0 15px", gap: "15px" }}
                        >
                          <p
                            className="ant-descriptions-item-content mb-0"
                            style={{ flex: 1, margin: 0 }}
                          >
                            <strong>Note : </strong>
                            Please select the material and enter the required
                            data. Alternatively, you can{" "}
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();

                                // Preparing Excel obj
                                let excelData: any = [];
                                (filterData || data || [])?.forEach(
                                  (row: any) => {
                                    let obj: any = {
                                      ID:
                                        row?.quotationLineId ||
                                        row?.rfqLineId ||
                                        "",
                                      "Material Id": row?.materialId || "",
                                      "Material Name": row?.materialName || "",
                                      Specification: row?.specification || "",
                                      Quantity:
                                        Number(row?.quantity || 0) +
                                        " " +
                                        (row?.uomName || ""),
                                      "Supply Quantity": "",
                                      "Min Purchase Quantity": "",
                                      HSN: "",
                                    };

                                    // Add Selling Price and Discount columns if MRP mode
                                    if (pricingMode === "MRP") {
                                      obj["Selling Price"] = "";
                                      obj["Discount"] = "";
                                    }

                                    obj["Price *(Without Tax)"] = "";
                                    obj["Delivery Lead Days *"] = "";

                                    if (
                                      OriginalData?.quotationInfo
                                        ?.quotationHeader?.deliveryDateType ===
                                      "LINE_LEVEL"
                                    ) {
                                      obj["Need By Date"] = `${dayjs(
                                        row?.needByDate
                                      ).format("DD-MMM-YYYY")}`;
                                    }
                                    if (
                                      OriginalData?.quotationInfo
                                        ?.quotationHeader?.deliveryLevelType ===
                                      "LINE_LEVEL"
                                    ) {
                                      try {
                                        const {
                                          addressLine1,
                                          addressLine2,
                                          cityName,
                                          stateName,
                                          countryName,
                                          pincode,
                                        } = row?.deliveryAddressName || {};
                                        obj["Delivery Address"] = [
                                          addressLine1,
                                          addressLine2,
                                          cityName,
                                          stateName,
                                          countryName,
                                          pincode,
                                        ]
                                          ?.filter(Boolean)
                                          ?.join(" ,");
                                      } catch (error) {
                                        console.log(
                                          "error while destructuring deliveryAddressName"
                                        );
                                      }
                                    }
                                    if (gstType == "cgst+sgst") {
                                      obj["SGST (%)"] = "";
                                      obj["CGST (%)"] = "";
                                    } else {
                                      obj["IGST (%)"] = "";
                                    }
                                    excelData.push(obj);
                                  }
                                );

                                ExportToXlsx(excelData, rfqId || "Quotation");
                              }}
                              target="_self"
                              style={{ textDecoration: "underline" }}
                            >
                              download the template
                            </a>{" "}
                            to fill in the details and upload it.
                          </p>
                          <Button
                            color="primary"
                            className="m-0"
                            style={{ height: 40, flexShrink: 0 }}
                            onClick={async () => {
                              try {
                                await form.validateFields();
                                if (areAllRowsFilled()) {
                                  showDrawer();
                                } else {
                                  message.error(
                                    "Please fill out all required fields."
                                  );
                                }
                              } catch (errorInfo) {
                                message.error(
                                  "Validation failed: Please fill out all required fields."
                                );
                                console.log("Validation failed:", errorInfo);
                              }
                            }}
                            disabled={selectedRowKeys.length === 0}
                          >
                            Preview
                          </Button>
                        </div>
                      </>
                    )}
                    {viewMode && (
                      <div className="d-flex justify-content-between m-0 p-0 mb-3">
                        <div className="w-70 d-flex align-items-start">
                          <div
                            className="alert alert-success mb-0"
                            style={{ padding: "8px 16px" }}
                          >
                            <Icon name="check-circle" /> Quotation submitted
                            successfully! You can view the details below.
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="table-responsive poTable">
                      <div
                        style={{
                          width: screenSize - 120 + "px",
                          margin: "0px auto",
                        }}
                      >
                        <Table
                          className="customTable"
                          columns={mergedColumns(columns, { gstType })}
                          rowSelection={viewMode ? undefined : rowSelection}
                          components={{
                            body: {
                              cell: EditableCell,
                            },
                          }}
                          dataSource={
                            viewMode
                              ? (invoiceableLines.length > 0
                                ? invoiceableLines
                                : filterData || []
                              ).map((item: any) => ({
                                ...item,
                                key: item?.quotationLineId || item?.id,
                              }))
                              : (filterData || []).map((item: any) => ({
                                ...item,
                                key: item?.quotationLineId,
                              }))
                          }
                          scroll={{ x: 1000 }}
                          expandable={{
                            expandedRowRender: (record: any) => (
                              <div className="expandableBody">
                                <div style={{ flex: 1, textAlign: "left" }}>
                                  <p style={{ margin: 0 }}>
                                    {record.description}
                                  </p>
                                  {record.file && (
                                    <div>
                                      <PaperClipOutlined /> &nbsp;
                                      <a
                                        href={record?.file?.fileName}
                                        download={record?.file?.fileName}
                                      >
                                        {record?.file?.fileName}
                                      </a>
                                    </div>
                                  )}
                                </div>
                                {OriginalData?.quotationInfo?.quotationHeader
                                  ?.deliveryDateType === "LINE_LEVEL" &&
                                  record.deliveryAddressName && (
                                    <div
                                      className="lineAddress"
                                      style={{ flex: 1 }}
                                    >
                                      <h6>Delivery Address</h6>
                                      <ShowAddressPopOver
                                        address={record.deliveryAddressName}
                                      />
                                    </div>
                                  )}
                              </div>
                            ),
                          }}
                          bordered
                          size="middle"
                          pagination={false}
                        />
                      </div>

                      {/* Additional Charges Section in View Mode */}
                      {viewMode && (
                        <div className="d-flex">
                          <Form form={form2} component={false}>
                            <Row className="mt-2 w-50">
                              <div>
                                {OriginalData?.quotationInfo?.quotationHeader
                                  ?.additionalCharges !== "Fixed" && (
                                    <div className="d-flex align-items-center">
                                      <h6 className="m-1 mb-0">
                                        Additional Charges (If Any)
                                      </h6>
                                      <div className="w-20 m-1 mb-0">
                                        {editAdditionalCharges ? (
                                          <a
                                            type={undefined}
                                            onClick={() => {
                                              if (
                                                additionalCharges.find(
                                                  (field: any, ind: number) => {
                                                    const name =
                                                      form2.getFieldValue(
                                                        `AdditionalCharges.${field?.id}.name`
                                                      );
                                                    const price =
                                                      form2.getFieldValue(
                                                        `AdditionalCharges.${field?.id}.price`
                                                      );
                                                    return !name || !price;
                                                  }
                                                )
                                              ) {
                                                return;
                                              }

                                              setAdditionalCharges([
                                                ...additionalCharges,
                                                {
                                                  name: "",
                                                  price: null,
                                                  id: nanoid(4),
                                                },
                                              ]);
                                              setShowSubmitBtm(true);
                                            }}
                                            className="addNewItem"
                                          >
                                            <PlusSquareOutlined />
                                          </a>
                                        ) : (
                                          <a
                                            type={undefined}
                                            onClick={() => {
                                              setEditAdditionalCharges(true);
                                            }}
                                            className="addNewItem"
                                          >
                                            <EditOutlined />
                                          </a>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                {additionalCharges?.map(
                                  (field: any, index: number) => {
                                    return (
                                      <Row
                                        key={field.id}
                                        className="m-2 mb-0 w-100"
                                      >
                                        <div className="w-50">
                                          {editAdditionalCharges ? (
                                            <Form.Item
                                              name={`AdditionalCharges.${field.id}.name`}
                                              label={
                                                <strong>
                                                  Additional Charge Name
                                                </strong>
                                              }
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "Charge Name is required",
                                                },
                                              ]}
                                              className="mb-0"
                                              initialValue={field.name}
                                            >
                                              <Input
                                                className="w-100"
                                                disabled={
                                                  !editAdditionalCharges
                                                }
                                                autoComplete="off"
                                                defaultValue={field.name}
                                              />
                                            </Form.Item>
                                          ) : (
                                            <strong>{field.name}</strong>
                                          )}
                                        </div>
                                        <div className="w-30">
                                          {editAdditionalCharges ? (
                                            <Form.Item
                                              name={`AdditionalCharges.${field.id}.price`}
                                              label={<strong>Price</strong>}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "Price is required",
                                                },
                                              ]}
                                              className="mb-0"
                                              initialValue={Number(field.price)}
                                            >
                                              <InputNumber
                                                min={0}
                                                step={0.01}
                                                disabled={
                                                  !editAdditionalCharges
                                                }
                                                defaultValue={Number(
                                                  field.price
                                                )}
                                                className="w-100"
                                                formatter={(value) =>
                                                  `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                  )
                                                }
                                                parser={(value: any) =>
                                                  value!.replace(
                                                    /\$\s?|(,*)/g,
                                                    ""
                                                  )
                                                }
                                                onKeyPress={(event) => {
                                                  if (
                                                    !/^[0-9.]+$/.test(event.key)
                                                  ) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                autoComplete="off"
                                              />
                                            </Form.Item>
                                          ) : (
                                            <strong>
                                              {formatCurrency(
                                                field.price,
                                                "INR"
                                              )}
                                            </strong>
                                          )}
                                        </div>
                                        <Col className="d-flex align-items-end w-15">
                                          {editAdditionalCharges && (
                                            <a
                                              onClick={() => {
                                                form2.setFieldsValue({
                                                  [`AdditionalCharges.${field.id}.name`]:
                                                    "",
                                                  [`AdditionalCharges.${field.id}.price`]:
                                                    null,
                                                });
                                                const newAdditionalCharges: any =
                                                  [];
                                                additionalCharges.forEach(
                                                  (fld: any, ind: number) => {
                                                    if (fld.id != field.id) {
                                                      const name =
                                                        form2.getFieldValue(
                                                          `AdditionalCharges.${fld.id}.name`
                                                        );
                                                      const price =
                                                        form2.getFieldValue(
                                                          `AdditionalCharges.${fld.id}.price`
                                                        );
                                                      if (name && price) {
                                                        newAdditionalCharges.push(
                                                          {
                                                            name,
                                                            price,
                                                            id: fld.id,
                                                          }
                                                        );
                                                      }
                                                    }
                                                  }
                                                );
                                                setAdditionalCharges(
                                                  newAdditionalCharges
                                                );
                                                setShowSubmitBtm(true);
                                              }}
                                              className="addNewItem"
                                            >
                                              <DeleteOutlined />
                                            </a>
                                          )}
                                        </Col>
                                      </Row>
                                    );
                                  }
                                )}
                                {additionalCharges?.length > 0 &&
                                  editAdditionalCharges && (
                                    <Button
                                      className="m-4 mt-3 mb-0"
                                      color="primary"
                                      onClick={() => {
                                        const newAdditionalCharges: any = [];
                                        additionalCharges.forEach(
                                          (field: any, index: number) => {
                                            const name = form2.getFieldValue(
                                              `AdditionalCharges.${field?.id}.name`
                                            );
                                            const price = form2.getFieldValue(
                                              `AdditionalCharges.${field?.id}.price`
                                            );

                                            if (name && price) {
                                              newAdditionalCharges.push({
                                                name,
                                                price,
                                                id: field?.id,
                                              });
                                            }
                                          }
                                        );
                                        setAdditionalCharges(() => {
                                          return newAdditionalCharges;
                                        });
                                        if (newAdditionalCharges?.length != 0) {
                                          setEditAdditionalCharges(false);
                                        }

                                        setShowSubmitBtm(true);
                                      }}
                                    >
                                      Save
                                    </Button>
                                  )}
                              </div>
                            </Row>
                          </Form>

                          <ViewTableTotals
                            data={invoiceableLines}
                            additionalCharges={additionalCharges}
                            invoice={true}
                          />
                        </div>
                      )}

                      <Row className="m-4 justify-content-end ">
                        {(signature?.isActive ||
                          invoiceSignature?.isActive) && (
                            <div className="signatureBtnWrapper">
                              <div className="d-flex justify-content-between align-items-center">
                                <strong>Signature</strong>
                              </div>
                              <div
                                style={{
                                  minHeight:
                                    signature?.image || invoiceSignature?.image
                                      ? "0px"
                                      : "120px",
                                  display:
                                    signature?.image || invoiceSignature?.image
                                      ? "block"
                                      : "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {(signature?.image ||
                                  invoiceSignature?.image) && (
                                    <>
                                      <div className="signatueImgWrapper border">
                                        <img
                                          src={
                                            signature?.image ||
                                            invoiceSignature?.image
                                          }
                                          alt="Signed"
                                          style={{ width: "160px" }}
                                        />
                                      </div>

                                      <div>
                                        <div className="form-group">
                                          <label
                                            className="form-label"
                                            htmlFor="signatureLabel"
                                          >
                                            Signature Label
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="signatureLabel"
                                            onChange={(e) => { }}
                                            disabled
                                            defaultValue={
                                              invoiceSignature?.label ||
                                              "Authorised Signatory"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                              </div>
                            </div>
                          )}
                      </Row>
                    </div>
                  </Form>
                </Panel>

                <Panel
                  header={
                    viewMode ? "Other Information" : "Customer Information"
                  }
                  key="3"
                >
                  <Descriptions title="" className="custom-description-title">
                    {/* During creation: Show Customer Instructions, Terms, Attachments in one section */}
                    {!viewMode && (
                      <>
                        <Descriptions.Item label="Customer Instructions">
                          {customerInstructions &&
                            customerInstructions.trim() !== "" ? (
                            <span
                              style={{
                                color: "#2263b3",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                setCustomerInstructionsVisible(true)
                              }
                            >
                              View Instructions
                            </span>
                          ) : (
                            <span style={{ color: "#999" }}>
                              No Instructions Available
                            </span>
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="Customer Terms and Conditions">
                          {customerTermsAndConditions &&
                            customerTermsAndConditions.trim() !== "" ? (
                            <span
                              style={{
                                color: "#2263b3",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() => setCustomerTermsVisible(true)}
                            >
                              View Terms and Conditions
                            </span>
                          ) : (
                            <span style={{ color: "#999" }}>
                              No Terms and Conditions Available
                            </span>
                          )}
                        </Descriptions.Item>
                        {customerAttachments?.length > 0 && (
                          <Descriptions.Item label="Customer Attachments">
                            <div>
                              <strong className="">
                                Attachments &nbsp;
                                <PaperClipOutlined />
                              </strong>
                              <div>
                                {customerAttachments?.map(
                                  (attachment: any, index: number) => (
                                    <div
                                      key={index}
                                      className="w-100 d-flex justify-content-between"
                                    >
                                      <div>
                                        <strong>{index + 1}.</strong>
                                        &nbsp;
                                        {attachment.name}
                                        &nbsp; &nbsp; &nbsp; &nbsp;
                                      </div>
                                      <div>
                                        <a
                                          href={
                                            attachment.link ||
                                            attachment.url ||
                                            "#"
                                          }
                                          download={
                                            attachment.name ||
                                            attachment.fileName
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          onClick={(e) => {
                                            if (
                                              !attachment.link &&
                                              !attachment.url
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          style={{
                                            color: "black",
                                            fontSize: "18px",
                                            cursor:
                                              attachment.link || attachment.url
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                        >
                                          <DownloadOutlined />
                                        </a>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </Descriptions.Item>
                        )}
                      </>
                    )}

                    {/* After creation (view mode): Show Customer info */}
                    {viewMode && (
                      <>
                        <Descriptions.Item label="Customer Instructions">
                          {customerInstructions &&
                            customerInstructions.trim() !== "" ? (
                            <span
                              style={{
                                color: "#2263b3",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                setCustomerInstructionsVisible(true)
                              }
                            >
                              View Instructions
                            </span>
                          ) : (
                            <span style={{ color: "#999" }}>
                              No Instructions Available
                            </span>
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="Customer Terms and Conditions">
                          {customerTermsAndConditions &&
                            customerTermsAndConditions.trim() !== "" ? (
                            <span
                              style={{
                                color: "#2263b3",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() => setCustomerTermsVisible(true)}
                            >
                              View Terms and Conditions
                            </span>
                          ) : (
                            <span style={{ color: "#999" }}>
                              No Terms and Conditions Available
                            </span>
                          )}
                        </Descriptions.Item>
                        {customerAttachments?.length > 0 && (
                          <Descriptions.Item label="Customer Attachments">
                            <div>
                              <strong className="">
                                Attachments &nbsp;
                                <PaperClipOutlined />
                              </strong>
                              <div>
                                {customerAttachments?.map(
                                  (attachment: any, index: number) => (
                                    <div
                                      key={index}
                                      className="w-100 d-flex justify-content-between"
                                    >
                                      <div>
                                        <strong>{index + 1}.</strong>
                                        &nbsp;
                                        {attachment.name}
                                        &nbsp; &nbsp; &nbsp; &nbsp;
                                      </div>
                                      <div>
                                        <a
                                          href={
                                            attachment.link ||
                                            attachment.url ||
                                            "#"
                                          }
                                          download={
                                            attachment.name ||
                                            attachment.fileName
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          onClick={(e) => {
                                            if (
                                              !attachment.link &&
                                              !attachment.url
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          style={{
                                            color: "black",
                                            fontSize: "18px",
                                            cursor:
                                              attachment.link || attachment.url
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                        >
                                          <DownloadOutlined />
                                        </a>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </Descriptions.Item>
                        )}
                      </>
                    )}
                  </Descriptions>
                </Panel>

                {/* Supplier Information Panel - Only in view mode */}
                {viewMode && (
                  <Panel header="Supplier Information" key="4">
                    <Descriptions title="" className="custom-description-title">
                      <Descriptions.Item label="Supplier Terms and Conditions">
                        <div className="d-flex align-items-center">
                          {termsAndConditions &&
                            termsAndConditions.trim() !== "" ? (
                            <>
                              <span
                                style={{
                                  color: "#2263b3",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => setTermsVisible(true)}
                              >
                                View Terms and Conditions
                              </span>
                              {viewMode && (
                                <EditOutlined
                                  onClick={() => {
                                    setIsSupplierTermsChanged(true);
                                    setTermsVisible(true);
                                    const currentTerms =
                                      termsAndConditions || "";
                                    setNewSupplierTermsAndConditions(
                                      currentTerms
                                    );
                                    methods.setValue(
                                      "supplierTermsAndConditions",
                                      currentTerms
                                    );
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "8px",
                                    fontSize: "16px",
                                  }}
                                />
                              )}
                            </>
                          ) : (
                            <>
                              <span style={{ color: "#999" }}>
                                No Terms and Conditions Available
                              </span>
                              {viewMode && (
                                <EditOutlined
                                  onClick={() => {
                                    setIsSupplierTermsChanged(true);
                                    setTermsVisible(true);
                                    const currentTerms =
                                      termsAndConditions || "";
                                    setNewSupplierTermsAndConditions(
                                      currentTerms
                                    );
                                    methods.setValue(
                                      "supplierTermsAndConditions",
                                      currentTerms
                                    );
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "8px",
                                    fontSize: "16px",
                                  }}
                                />
                              )}
                            </>
                          )}
                        </div>
                      </Descriptions.Item>
                      <Descriptions.Item label="Supplier Attachments">
                        <div>
                          <strong className="">
                            Attachments &nbsp;
                            <PaperClipOutlined />
                          </strong>
                          <div>
                            {attachments?.length > 0 &&
                              attachments.map(
                                (attachment: any, index: number) => (
                                  <div
                                    key={index}
                                    className="w-100 d-flex justify-content-between align-items-center"
                                    style={{ marginBottom: "8px" }}
                                  >
                                    <div className="d-flex align-items-center">
                                      <strong>{index + 1}.</strong>
                                      &nbsp;
                                      {attachment.name || attachment.fileName}
                                      <a
                                        href={
                                          attachment.link ||
                                          attachment.url ||
                                          "#"
                                        }
                                        download={
                                          attachment.name || attachment.fileName
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                          if (
                                            !attachment.link &&
                                            !attachment.url
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                          marginLeft: "10px",
                                          cursor:
                                            attachment.link || attachment.url
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                      >
                                        <DownloadOutlined />
                                      </a>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <a
                                        onClick={(e) => {
                                          e.preventDefault();
                                          Swal.fire({
                                            title: "Are you sure?",
                                            text: "Do you want to delete this attachment?",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText:
                                              "Yes, delete it!",
                                          }).then((result) => {
                                            if (result.isConfirmed) {
                                              // Remove from attachments list
                                              const updatedAttachments =
                                                attachments.filter(
                                                  (item: any, idx: number) =>
                                                    idx !== index
                                                );
                                              setAttachments(
                                                updatedAttachments
                                              );
                                              // Track deleted attachment for API call
                                              if (attachment.docId) {
                                                setDeletedAttachments(
                                                  (prev: any[]) => [
                                                    ...prev,
                                                    {
                                                      docId: attachment.docId,
                                                      moduleFileType:
                                                        attachment.moduleFileType ||
                                                        "attachments",
                                                    },
                                                  ]
                                                );
                                              }
                                              setShowSubmitBtm(true);
                                              Swal.fire(
                                                "Deleted!",
                                                "Attachment has been deleted.",
                                                "success"
                                              );
                                            }
                                          });
                                        }}
                                        style={{
                                          color: "#ff4d4f",
                                          fontSize: "18px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <DeleteOutlined />
                                      </a>
                                    </div>
                                  </div>
                                )
                              )}
                            {attachments?.length === 0 && (
                              <div style={{ color: "#999", marginTop: "8px" }}>
                                No attachments available
                              </div>
                            )}
                          </div>
                          <div style={{ marginTop: "10px" }}>
                            <Upload
                              beforeUpload={() => false}
                              multiple={true}
                              onChange={(info: any) => {
                                const fileList = info.fileList.slice(-3);
                                const newFiles = fileList
                                  .filter((file: any) => file.originFileObj)
                                  .map((file: any) => file.originFileObj);
                                if (newFiles.length > 0) {
                                  const newAttachList = newFiles.map(
                                    (file: any) => ({
                                      name: file.name,
                                      file: file,
                                      uid: file.uid,
                                    })
                                  );
                                  setNewAttachments((prev: any[]) => [
                                    ...prev,
                                    ...newAttachList,
                                  ]);
                                  setAttachments((prev: any[]) => [
                                    ...prev,
                                    ...newAttachList,
                                  ]);
                                  setShowSubmitBtm(true);
                                }
                              }}
                              showUploadList={false}
                            >
                              <AntButton
                                icon={<PlusSquareOutlined />}
                                size="small"
                              >
                                Add Attachment
                              </AntButton>
                            </Upload>
                          </div>
                        </div>
                      </Descriptions.Item>
                      {/* Required Docs with editable files */}
                      {requiredDOC && requiredDOC.length > 0 && (
                        <Descriptions.Item label="">
                          <div>
                            <strong className="">
                              Required Documents &nbsp;
                            </strong>
                            {requiredDOC.map((doc: any, index: number) => (
                              <div
                                key={doc.quotationDocNameId}
                                className="w-auto m-3 mt-2 mb-0"
                              >
                                <div>
                                  <div className="d-flex align-items-center">
                                    <strong>
                                      {doc.documentName}{" "}
                                      {doc.mandatory == 1 && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </strong>
                                    {/* Upload icon next to document name for replacing - only if file already exists */}
                                    {viewMode &&
                                      doc.dms &&
                                      doc.dms.length > 0 && (
                                        <Upload
                                          {...uploadProps}
                                          className="w-auto"
                                          style={{ marginLeft: "8px" }}
                                          onChange={(info: any) => {
                                            if (info.file.status === "removed")
                                              return;
                                            const file =
                                              info.file.originFileObj ||
                                              info.file;
                                            if (
                                              file &&
                                              info.file.status !== "uploading"
                                            ) {
                                              // Track old file for deletion if it exists and has docId
                                              const oldFile =
                                                doc.dms && doc.dms.length > 0
                                                  ? doc.dms[0]
                                                  : null;
                                              if (
                                                oldFile &&
                                                oldFile.docId &&
                                                !oldFile.isNew
                                              ) {
                                                setDeletedAttachments(
                                                  (prev: any[]) => {
                                                    // Check if already added to avoid duplicates
                                                    const exists = prev.some(
                                                      (item: any) =>
                                                        item.docId ===
                                                        oldFile.docId
                                                    );
                                                    if (exists) return prev;
                                                    return [
                                                      ...prev,
                                                      {
                                                        docId: oldFile.docId,
                                                        moduleFileType:
                                                          "Supplier Docs",
                                                        supplierDocQuoteId:
                                                          oldFile.supplierDocQuoteId,
                                                      },
                                                    ];
                                                  }
                                                );
                                              }
                                              // Update the doc in requiredDOC state with new file
                                              const updatedRequiredDOC =
                                                requiredDOC.map((d: any) => {
                                                  if (
                                                    d.quotationDocNameId ===
                                                    doc.quotationDocNameId
                                                  ) {
                                                    // Replace existing file with new one - ensure only one file
                                                    const newFileItem = {
                                                      fileName: file.name,
                                                      file: file,
                                                      quotationDocNameId:
                                                        doc.quotationDocNameId,
                                                      supplierDocQuoteId:
                                                        doc.supplierDocQuoteId,
                                                      isNew: true,
                                                    };
                                                    return {
                                                      ...d,
                                                      dms: [newFileItem], // Replace entire array with just the new file
                                                    };
                                                  }
                                                  return d;
                                                });
                                              setRequiredDOC(
                                                updatedRequiredDOC
                                              );
                                              setShowSubmitBtm(true);
                                            }
                                          }}
                                        >
                                          <AntButton
                                            type="link"
                                            icon={<CloudUploadOutlined />}
                                            style={{
                                              padding: 0,
                                              marginLeft: "4px",
                                            }}
                                          />
                                        </Upload>
                                      )}
                                  </div>
                                  {/* Display file names as clickable links */}
                                  {doc.dms && doc.dms.length > 0 && (
                                    <div style={{ marginTop: "5px" }}>
                                      {doc.dms.map(
                                        (fileItem: any, fileIndex: number) => (
                                          <div
                                            key={
                                              fileItem.docId ||
                                              fileItem.fileName ||
                                              `file-${fileIndex}-${doc.quotationDocNameId}`
                                            }
                                            className="d-flex justify-content-between align-items-center"
                                            style={{
                                              marginTop: "3px",
                                              marginBottom: "3px",
                                            }}
                                          >
                                            <div className="d-flex align-items-center">
                                              {fileItem.filePath ? (
                                                <a
                                                  href={fileItem.filePath}
                                                  download={fileItem.fileName}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{
                                                    color: "#2263b3",
                                                    textDecoration: "underline",
                                                  }}
                                                >
                                                  {fileItem.fileName}
                                                </a>
                                              ) : fileItem.fileName ? (
                                                <span>{fileItem.fileName}</span>
                                              ) : null}
                                            </div>
                                            {/* Delete icon for view mode */}
                                            {viewMode && (
                                              <a
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  Swal.fire({
                                                    title: "Are you sure?",
                                                    text: "Do you want to delete this file?",
                                                    icon: "warning",
                                                    showCancelButton: true,
                                                    confirmButtonColor:
                                                      "#3085d6",
                                                    cancelButtonColor: "#d33",
                                                    confirmButtonText:
                                                      "Yes, delete it!",
                                                  }).then((result) => {
                                                    if (result.isConfirmed) {
                                                      // Update the doc in requiredDOC state
                                                      const updatedRequiredDOC =
                                                        requiredDOC.map(
                                                          (d: any) => {
                                                            if (
                                                              d.quotationDocNameId ===
                                                              doc.quotationDocNameId
                                                            ) {
                                                              const updatedDms =
                                                                (
                                                                  d.dms || []
                                                                ).filter(
                                                                  (
                                                                    f: any,
                                                                    idx: number
                                                                  ) =>
                                                                    idx !==
                                                                    fileIndex
                                                                );
                                                              return {
                                                                ...d,
                                                                dms: updatedDms,
                                                              };
                                                            }
                                                            return d;
                                                          }
                                                        );
                                                      setRequiredDOC(
                                                        updatedRequiredDOC
                                                      );
                                                      // Track deleted file for API call only if it's an existing file (has docId)
                                                      if (
                                                        fileItem.docId &&
                                                        !fileItem.isNew
                                                      ) {
                                                        setDeletedAttachments(
                                                          (prev: any[]) => [
                                                            ...prev,
                                                            {
                                                              docId:
                                                                fileItem.docId,
                                                              moduleFileType:
                                                                "Supplier Docs",
                                                              supplierDocQuoteId:
                                                                fileItem.supplierDocQuoteId,
                                                            },
                                                          ]
                                                        );
                                                      }
                                                      setShowSubmitBtm(true);
                                                      Swal.fire(
                                                        "Deleted!",
                                                        "File has been deleted.",
                                                        "success"
                                                      );
                                                    }
                                                  });
                                                }}
                                                style={{
                                                  color: "#ff4d4f",
                                                  fontSize: "18px",
                                                  marginLeft: "8px",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <DeleteOutlined />
                                              </a>
                                            )}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                                  {/* Upload button for view mode when no file exists */}
                                  {viewMode &&
                                    (!doc.dms || doc.dms.length === 0) && (
                                      <div style={{ marginTop: "8px" }}>
                                        <Upload
                                          {...uploadProps}
                                          className="w-auto"
                                          onChange={(info: any) => {
                                            if (info.file.status === "removed")
                                              return;
                                            const file =
                                              info.file.originFileObj ||
                                              info.file;
                                            if (file) {
                                              // Update the doc in requiredDOC state with new file
                                              const updatedRequiredDOC =
                                                requiredDOC.map((d: any) => {
                                                  if (
                                                    d.quotationDocNameId ===
                                                    doc.quotationDocNameId
                                                  ) {
                                                    const newFileItem = {
                                                      fileName: file.name,
                                                      file: file,
                                                      quotationDocNameId:
                                                        doc.quotationDocNameId,
                                                      supplierDocQuoteId:
                                                        doc.supplierDocQuoteId,
                                                      isNew: true,
                                                    };
                                                    return {
                                                      ...d,
                                                      dms: [newFileItem],
                                                    };
                                                  }
                                                  return d;
                                                });
                                              setRequiredDOC(
                                                updatedRequiredDOC
                                              );
                                              setShowSubmitBtm(true);
                                            }
                                          }}
                                        >
                                          <AntButton
                                            type="link"
                                            icon={<CloudUploadOutlined />}
                                            style={{ padding: 0 }}
                                          >
                                            Click to Upload
                                          </AntButton>
                                        </Upload>
                                      </div>
                                    )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Descriptions.Item>
                      )}
                    </Descriptions>
                  </Panel>
                )}
              </AntCollapse>

              <Drawer
                title={
                  <div className="d-flex justify-content-between align-items-center">
                    <strong>Create Quotation</strong>
                    <div style={{ textAlign: "right" }}>
                      {disableCreateQuoteSubmit ? (
                        <Button color="primary" type="button">
                          <Spinner size="sm" color="light" />
                        </Button>
                      ) : (
                        <Button
                          onClick={() => {
                            form2.submit();
                          }}
                          color="primary"
                          className="m-3 mt-0 mb-0"
                        >
                          Create Quotation
                        </Button>
                      )}
                    </div>
                  </div>
                }
                placement="right"
                onClose={closeDrawer}
                open={drawerVisible}
                width="85vw"
                style={{
                  position: "absolute",
                  zIndex: 1100,
                }}
                styles={{ body: { paddingBottom: 80 } }}
              >
                <Form
                  initialValues={{
                    approvals: "N",
                  }}
                  form={form2}
                  layout="vertical"
                  onValuesChange={() => {
                    if (!viewMode) {
                      setShowSubmitBtm(true);
                    }
                  }}
                  onFinish={(data) => {
                    if (!invoiceSignature?.image) {
                      Swal.fire({
                        icon: "info",
                        title: "Signature",
                        text: "Signature is required",
                      });
                      return;
                    }
                    Swal.fire({
                      title: "Are you sure?",
                      text: "You are about to create!",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Yes, Create!",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        setDisableSubmit(true);
                        setDisableCreateQuoteSubmit(true);
                        createInvoice(data);
                      }
                    });
                  }}
                  requiredMark={false}
                >
                  <AntCollapse defaultActiveKey={["1", "2"]} className="mt-3">
                    <Panel
                      header={<h6>Billing & Other Information</h6>}
                      key="1"
                    >
                      <div className="d-flex justify-content-around ">
                        <div className="w-50">
                          <div className="justify-start w-100  flex-wrap pt-0">
                            <div className={` w-50  paddingLeft10`}>
                              <div className=" pt-1">
                                <div className="data-label w-90 mb-1">
                                  Billing Address
                                </div>
                                <div className="data-value w-90">
                                  <ShowBillingAddress
                                    address={
                                      OriginalData?.quotationInfo
                                        ?.quotationHeader?.billingAddressName
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            {OriginalData?.quotationInfo?.quotationHeader
                              ?.deliveryAddressName && (
                                <div className="w-40 paddingLeft10 ">
                                  <div className=" pt-1">
                                    <div className="data-label w-9 mb-1">
                                      Delivery Address
                                    </div>
                                    <div className="data-value w-90">
                                      <ShowDeliveryAddress
                                        address={
                                          OriginalData?.quotationInfo
                                            ?.quotationHeader?.deliveryAddressName
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                        <div className="border-end"></div>
                        <div className="w-45">
                          <div className="justify-start w-100  flex-wrap pt-3">
                            <Form.Item
                              name="negotiable"
                              label={
                                <div className="data-label w-90 mb-1">
                                  Negotiable
                                </div>
                              }
                              className="w-50 p-3 paddingLeft10  pt-0 pb-0"
                              rules={[
                                {
                                  required: true,
                                  message: "Please select type",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select"
                                onChange={(value) => {
                                  setNewNegotiableType(value);
                                }}
                              >
                                <Option value="Y">Yes</Option>
                                <Option value="N">No</Option>
                              </Select>
                            </Form.Item>

                            <Form.Item
                              name="invoiceDate"
                              label={
                                <div className="data-label w-90 mb-1">
                                  Validity Date
                                </div>
                              }
                              className="w-50 p-3 paddingLeft10  pt-0 pb-0"
                              rules={[
                                {
                                  required: true,
                                  message: "Please select Validity Date",
                                },
                              ]}
                            >
                              <DatePicker
                                className="w-100"
                                placeholder="Validity Date"
                                minDate={dayjs().add(0, "day")}
                                onChange={(e) => {
                                  setInvoiceDate(e);
                                  setNewValidityDate(e);
                                }}
                              />
                            </Form.Item>

                            {OriginalData?.quotationInfo?.quotationHeader
                              ?.paymentTerms == "Credit" && (
                                <Form.Item
                                  name="paymentDays"
                                  label={
                                    <div className="data-label w-100 mb-1">
                                      Supplier Credit Days
                                    </div>
                                  }
                                  className="w-50 p-2 paddingLeft10  pt-0 pb-0"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please Enter Credit Days",
                                    },
                                  ]}
                                >
                                  <Input
                                    className="w-100"
                                    type="number"
                                    placeholder="Enter  Supplier Credit Days"
                                    onChange={(e) => {
                                      setNewPaymentDays(e.target.value);
                                    }}
                                  />
                                </Form.Item>
                              )}
                            <Form.Item
                              name="supplierPreferredBrands"
                              label={
                                <div
                                  className="data-label w-90 mb-1"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Preferred Brands / Make
                                </div>
                              }
                              className="w-100 p-3 paddingLeft10  pt-0 pb-0"
                              style={{ minWidth: "400px" }}
                            >
                              <Select
                                mode="tags"
                                style={{ width: "100%", minWidth: "400px", minHeight: "38px" }}
                                placeholder="Select or type to add brands"
                                value={newPreferredBrandsArray || []}
                                onChange={(val: string[]) =>
                                  handlePreferredBrandsChange(val)
                                }
                                options={brandOptions}
                                tokenSeparators={[","]}
                                filterOption={(input, option) => {
                                  const label = option?.label?.toString()?.toLowerCase() || "";
                                  const val = option?.value?.toString()?.toLowerCase() || "";
                                  return label.includes(input.toLowerCase()) || val.includes(input.toLowerCase());
                                }}
                                maxTagCount="responsive"
                                dropdownRender={(menu) => (
                                  <>
                                    {newPreferredBrandsArray?.length === brandOptions?.length ? (
                                      <>
                                        <a className="addNewItem" onClick={() => handlePreferredBrandsChange([])}>Clear All</a>
                                        <hr />
                                      </>
                                    ) : (
                                      <>
                                        {brandOptions?.length > 6 && (
                                          <a className="addNewItem" onClick={() => handlePreferredBrandsChange(brandOptions.map((o) => o.value))}>Select All</a>
                                        )}
                                        <hr />
                                      </>
                                    )}
                                    <div className="drop-down-multiselect">{menu}</div>
                                  </>
                                )}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </Panel>

                    <Panel header={<h6>Material Information</h6>} key="2">
                      <div className="table-responsive poTable">
                        <div
                          style={{
                            width: screenSize - 350 + "px",
                            margin: "0px auto 15px auto",
                          }}
                        >
                          <Table
                            className="customTable"
                            columns={previewColumns}
                            dataSource={invoiceableLines}
                            scroll={{ x: 1000 }}
                            expandable={{
                              expandedRowRender: (record: any) => (
                                <div className="expandableBody">
                                  <div style={{ flex: 1, textAlign: "left" }}>
                                    <p style={{ margin: 0 }}>
                                      {record.description}
                                    </p>
                                    {record.file && (
                                      <div>
                                        <PaperClipOutlined /> &nbsp;
                                        <a
                                          href={record?.file?.fileName}
                                          download={record?.file?.fileName}
                                        >
                                          {record?.file?.fileName}
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ),
                            }}
                            bordered
                            size="middle"
                            pagination={false}
                          />
                        </div>
                      </div>

                      <div className="d-flex">
                        <Row className="mt-2 w-50">
                          <div>
                            {OriginalData?.quotationInfo?.quotationHeader
                              ?.additionalCharges !== "Fixed" && (
                                <div className="d-flex align-items-center">
                                  <h6 className="m-1 mb-0">
                                    Additional Charges (If Any)
                                  </h6>
                                  <div className="w-20 m-1 mb-0">
                                    {editAdditionalCharges ? (
                                      <a
                                        type={undefined}
                                        onClick={() => {
                                          if (
                                            additionalCharges.find(
                                              (field: any, ind: number) => {
                                                const name = form2.getFieldValue(
                                                  `AdditionalCharges.${field?.id}.name`
                                                );
                                                const price = form2.getFieldValue(
                                                  `AdditionalCharges.${field?.id}.price`
                                                );
                                                return !name || !price;
                                              }
                                            )
                                          ) {
                                            return;
                                          }

                                          setAdditionalCharges([
                                            ...additionalCharges,
                                            {
                                              name: "",
                                              price: null,
                                              id: nanoid(4),
                                            },
                                          ]);
                                          setShowSubmitBtm(true);
                                        }}
                                        className="addNewItem"
                                      >
                                        <PlusSquareOutlined />
                                      </a>
                                    ) : (
                                      <a
                                        type={undefined}
                                        onClick={() => {
                                          setEditAdditionalCharges(true);
                                        }}
                                        className="addNewItem"
                                      >
                                        <EditOutlined />
                                      </a>
                                    )}
                                  </div>
                                </div>
                              )}
                            {additionalCharges.map(
                              (field: any, index: number) => (
                                <Row key={field.id} className="m-2 mb-0 w-100">
                                  <div className="w-50">
                                    {editAdditionalCharges ? (
                                      <Form.Item
                                        name={`AdditionalCharges.${field.id}.name`}
                                        label={
                                          <strong>
                                            Additional Charge Name
                                          </strong>
                                        }
                                        rules={[
                                          {
                                            required: true,
                                            message: "Charge Name is required",
                                          },
                                        ]}
                                        className="mb-0"
                                      >
                                        <Input
                                          className="w-100"
                                          disabled={!editAdditionalCharges}
                                          autoComplete="off"
                                        />
                                      </Form.Item>
                                    ) : (
                                      <strong>{field.name}</strong>
                                    )}
                                  </div>
                                  <div className="w-30">
                                    {editAdditionalCharges ? (
                                      <Form.Item
                                        name={`AdditionalCharges.${field.id}.price`}
                                        label={<strong>Price (INR)</strong>}
                                        rules={[
                                          {
                                            required: true,
                                            message: "Price is required",
                                          },
                                        ]}
                                        className="mb-0"
                                      >
                                        <InputNumber
                                          min={0}
                                          step={0.01}
                                          disabled={!editAdditionalCharges}
                                          className="w-100"
                                          formatter={(value) =>
                                            `${value}`.replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                          }
                                          parser={(value: any) =>
                                            value!.replace(/\$\s?|(,*)/g, "")
                                          }
                                          onKeyPress={(event) => {
                                            if (!/^[0-9.]$/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          autoComplete="off"
                                        />
                                      </Form.Item>
                                    ) : (
                                      <strong>
                                        {formatCurrency(field.price, "INR")}
                                      </strong>
                                    )}
                                  </div>
                                  <Col className="d-flex align-items-end w-15">
                                    {editAdditionalCharges && (
                                      <a
                                        href="#dropdownitem"
                                        onClick={() => {
                                          form2.setFieldsValue({
                                            [`AdditionalCharges.${field.id}.name`]:
                                              "",
                                            [`AdditionalCharges.${field.id}.price`]:
                                              null,
                                          });
                                          const newAdditionalCharges: any = [];
                                          additionalCharges.forEach(
                                            (fld: any, ind: number) => {
                                              if (fld.id != field.id) {
                                                const name =
                                                  form2.getFieldValue(
                                                    `AdditionalCharges.${fld.id}.name`
                                                  );
                                                const price =
                                                  form2.getFieldValue(
                                                    `AdditionalCharges.${fld.id}.price`
                                                  );
                                                if (name && price) {
                                                  newAdditionalCharges.push({
                                                    name,
                                                    price,
                                                    id: fld.id,
                                                  });
                                                }
                                              }
                                            }
                                          );
                                          setAdditionalCharges(
                                            newAdditionalCharges
                                          );
                                          setShowSubmitBtm(true);
                                        }}
                                        className="addNewItem"
                                      >
                                        <DeleteOutlined />
                                      </a>
                                    )}
                                  </Col>
                                </Row>
                              )
                            )}
                            {additionalCharges.length > 0 &&
                              editAdditionalCharges && (
                                <Button
                                  className="m-4 mt-3 mb-0"
                                  color="primary"
                                  onClick={() => {
                                    const newAdditionalCharges: any = [];
                                    additionalCharges.forEach(
                                      (field: any, index: number) => {
                                        const name = form2.getFieldValue(
                                          `AdditionalCharges.${field?.id}.name`
                                        );
                                        const price = form2.getFieldValue(
                                          `AdditionalCharges.${field?.id}.price`
                                        );
                                        if (name && price) {
                                          newAdditionalCharges.push({
                                            name,
                                            price,
                                            id: field?.id,
                                          });
                                        }
                                      }
                                    );
                                    setAdditionalCharges(() => {
                                      return newAdditionalCharges;
                                    });
                                    setShowSubmitBtm(true);
                                    if (newAdditionalCharges.length != 0) {
                                      setEditAdditionalCharges(false);
                                    }
                                  }}
                                >
                                  Save
                                </Button>
                              )}
                          </div>
                        </Row>

                        <ViewTableTotals
                          data={invoiceableLines}
                          additionalCharges={additionalCharges}
                          invoice={true}
                        />
                      </div>
                      <Row className="m-4 justify-content-end ">
                        {invoiceSignature?.isActive ? (
                          <div className="signatureBtnWrapper">
                            <div className="d-flex justify-content-between align-items-center">
                              <strong>Signature</strong>
                              <a
                                style={{
                                  fontSize: "14px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setInvoiceSignature((prev: any) => ({
                                    ...prev,
                                    isActive: false,
                                    image: null,
                                    label: "Authorised Signatory",
                                  }));
                                }}
                              >
                                <Icon name="cross" className="pointer" />
                              </a>
                            </div>
                            <div
                              style={{
                                minHeight: invoiceSignature?.image
                                  ? "0px"
                                  : "120px",
                                display: invoiceSignature?.image
                                  ? "block"
                                  : "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {!invoiceSignature?.image && (
                                <Button
                                  color="btn-dim btn"
                                  onClick={() => {
                                    setShowCropModel(true);
                                  }}
                                >
                                  <Icon
                                    name="upload-cloud"
                                    className="pointer"
                                  />
                                  <span>Upload</span>
                                </Button>
                              )}
                              {invoiceSignature?.image && (
                                <>
                                  <div className="signatueImgWrapper border">
                                    <img
                                      src={invoiceSignature?.image}
                                      alt="Signed"
                                      style={{ width: "160px" }}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Button
                                      color="btn-dim btn"
                                      onClick={() => {
                                        setInvoiceSignature((pre: any) => {
                                          return { ...pre, image: null };
                                        });
                                      }}
                                    >
                                      <span>Reset</span>
                                      <Icon name="redo" className="pointer" />
                                    </Button>
                                  </div>
                                  <div>
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        htmlFor="signatureLabel"
                                      >
                                        Signature Label
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="signatureLabel"
                                        onChange={(e) => {
                                          setInvoiceSignature((pre: any) => {
                                            return {
                                              ...pre,
                                              label: e.target.value,
                                            };
                                          });
                                        }}
                                        defaultValue={
                                          invoiceSignature?.label ||
                                          "Authorised Signatory"
                                        }
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>

                            {!invoiceSignature?.image && (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Button
                                    color="btn-dim btn"
                                    onClick={() => setShowSignatureModel(true)}
                                  >
                                    <Icon name="pen" />
                                    <span>Use Signature Pad</span>
                                  </Button>
                                </div>
                              </>
                            )}
                          </div>
                        ) : (
                          <div
                            style={{
                              border: "1px solid #e5ecf7",
                              backgroundColor: "#f7faff",
                              padding: "10px",
                              marginLeft: "10px",
                              width: "22%",
                              borderRadius: "5px",
                              textAlign: "center",
                            }}
                          >
                            <Button
                              color="btn-dim btn"
                              onClick={() => {
                                setInvoiceSignature((pre: any) => {
                                  return { ...pre, isActive: true };
                                });
                              }}
                            >
                              <Icon name="edit" className="pointer" />
                              <span>Add Signature</span>
                            </Button>
                          </div>
                        )}
                      </Row>
                    </Panel>
                    <Panel header={<h6>Terms and Conditions</h6>} key="3">
                      <div>
                        <FormProvider {...methods}>
                          <form>
                            <FormTextArea
                              name="supplierTermsAndConditions"
                              label={undefined}
                              placeholder="Enter Terms and Conditions"
                            />
                          </form>
                        </FormProvider>
                      </div>
                    </Panel>
                    <Panel header={<h6>Attachments (If Any)</h6>} key="4">
                      <div className="w-100 d-flex m-2">
                        <div className="w-25">
                          <Form.Item
                            name="attachDC"
                            label={<strong>Attach Documents</strong>}
                            valuePropName="fileList"
                            getValueFromEvent={(e: any) => e?.fileList}
                            rules={[
                              {
                                required: false,
                                message: "Please upload at least one document.",
                              },
                            ]}
                          >
                            <Upload
                              beforeUpload={beforeUpload}
                              onChange={handleChangeAttachment}
                              multiple={true}
                              fileList={documentsAttached}
                              accept=".pdf,.jpg,.jpeg,.png"
                              className="w-100"
                              showUploadList={{ showPreviewIcon: false }}
                              itemRender={(
                                originNode,
                                file,
                                fileList,
                                actions
                              ) => {
                                // Customize the rendering of each file to remove the tooltip
                                return React.cloneElement(
                                  originNode as React.ReactElement,
                                  {
                                    title: null, // Removes the tooltip entirely
                                  }
                                );
                              }}
                            >
                              <AntButton icon={<UploadOutlined />}>
                                Click to Upload
                              </AntButton>
                            </Upload>
                          </Form.Item>
                        </div>

                        {requiredDOC &&
                          requiredDOC.length > 0 &&
                          requiredDOC.map((doc: any) => (
                            <div className="w-25" key={doc.quotationDocNameId}>
                              <Form.Item
                                name={`doc_${doc.quotationDocNameId}`}
                                label={
                                  <strong>
                                    {doc.documentName}
                                    {doc.mandatory == 1 && (
                                      <span style={{ color: "red" }}> *</span>
                                    )}
                                  </strong>
                                }
                                valuePropName="fileList"
                                getValueFromEvent={(e: any) =>
                                  Array.isArray(e) ? e : e?.fileList
                                }
                                rules={[
                                  {
                                    required: doc.mandatory == 1,
                                    message: `${doc.documentName} is required`,
                                  },
                                ]}
                              >
                                <Upload {...uploadProps} className="w-100">
                                  <AntButton icon={<UploadOutlined />}>
                                    Click to Upload
                                  </AntButton>
                                </Upload>
                              </Form.Item>
                            </div>
                          ))}
                      </div>
                    </Panel>
                  </AntCollapse>
                  {showCropModel && (
                    <CropperComponent
                      modal={showCropModel}
                      toggle={() => setShowCropModel(!showCropModel)}
                      onSave={(data: string) => {
                        setInvoiceSignature((pre: any) => {
                          return { ...pre, image: data };
                        });
                        setShowCropModel(false);
                      }}
                    />
                  )}
                  {showSignatureModel && (
                    <SignatureModal
                      modal={showSignatureModel}
                      toggle={() => setShowSignatureModel(!showSignatureModel)}
                      onSave={(data: string) => {
                        setInvoiceSignature((pre: any) => {
                          return { ...pre, image: data };
                        });
                        setShowSignatureModel(false);
                      }}
                    />
                  )}
                </Form>
              </Drawer>

              {/* Customer Instructions Modal */}
              <AntModal
                title="Customer Instructions"
                open={customerInstructionsVisible}
                footer={null}
                onCancel={() => setCustomerInstructionsVisible(false)}
                width="60%"
                styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
              >
                {customerInstructions && customerInstructions.trim() !== "" ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: customerInstructions,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "400px",
                    }}
                  >
                    <Empty description="No Instructions Available for this Quotation" />
                  </div>
                )}
              </AntModal>
              {/* Customer Terms and Conditions Modal */}
              <AntModal
                title="Customer Terms and Conditions"
                open={customerTermsVisible}
                footer={null}
                onCancel={() => setCustomerTermsVisible(false)}
                width="60%"
                styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
              >
                {customerTermsAndConditions &&
                  customerTermsAndConditions.trim() !== "" ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: customerTermsAndConditions,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "400px",
                    }}
                  >
                    <Empty description="No Terms and Conditions Available for this Quotation" />
                  </div>
                )}
              </AntModal>
              {/* Supplier Instructions Modal */}
              <AntModal
                title="Supplier Instructions"
                open={instructionsVisible}
                footer={null}
                onCancel={() => setInstructionsVisible(false)}
                width="60%"
                styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
              >
                {supplierInstructions && supplierInstructions.trim() !== "" ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: supplierInstructions,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "400px",
                    }}
                  >
                    <Empty description="No Instructions Available for this Quotation" />
                  </div>
                )}
              </AntModal>
              {/* Supplier Terms and Conditions Modal */}
              <AntModal
                title={undefined}
                open={termsVisible}
                footer={null}
                onCancel={() => {
                  if (isSupplierTermsChanged) {
                    // Reset form values to current saved terms when closing in edit mode
                    const currentTerms = termsAndConditions || "";
                    setNewSupplierTermsAndConditions(currentTerms);
                    methods.reset({
                      supplierTermsAndConditions: currentTerms,
                    });
                    methods.setValue(
                      "supplierTermsAndConditions",
                      currentTerms,
                      { shouldValidate: false, shouldDirty: false }
                    );
                    // Force form field re-render by updating key
                    setTermsFormKey((prev) => prev + 1);
                  }
                  setIsSupplierTermsChanged(false);
                  setTermsVisible(false);
                }}
                width="60%"
                styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ padding: "12px" }}
                >
                  <h5 style={{ margin: 0, marginRight: "8px" }}>
                    Terms and Conditions
                  </h5>
                  {!isSupplierTermsChanged && (
                    <EditOutlined
                      onClick={() => {
                        setIsSupplierTermsChanged(true);
                        const currentTerms = termsAndConditions || "";
                        setNewSupplierTermsAndConditions(currentTerms);
                        methods.setValue(
                          "supplierTermsAndConditions",
                          currentTerms
                        );
                        // Force form field re-render when entering edit mode
                        setTermsFormKey((prev) => prev + 1);
                      }}
                      style={{ cursor: "pointer", fontSize: "16px" }}
                    />
                  )}
                </div>
                {isSupplierTermsChanged ? (
                  <FormProvider {...methods}>
                    <form>
                      <div className="mt-1 mb-3">
                        <FormTextArea
                          key={`terms-${termsFormKey}-${termsAndConditions}`}
                          defaultValue={newSupplierTermsAndConditions}
                          name="supplierTermsAndConditions"
                          label=""
                          placeholder="Enter Terms and Conditions"
                          rows={10}
                        />
                      </div>
                    </form>
                  </FormProvider>
                ) : termsAndConditions && termsAndConditions.trim() !== "" ? (
                  <div
                    className="m-3"
                    dangerouslySetInnerHTML={{
                      __html: termsAndConditions,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "400px",
                    }}
                  >
                    <Empty description="No Terms and Conditions Available for this Quotation" />
                  </div>
                )}
                {isSupplierTermsChanged && (
                  <div className="d-flex justify-content-end m-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        // Get the form value, ensuring empty string is preserved
                        const formValue = methods.getValues(
                          "supplierTermsAndConditions"
                        );
                        const updatedTerms =
                          formValue !== undefined && formValue !== null
                            ? String(formValue).trim()
                            : newSupplierTermsAndConditions !== undefined &&
                              newSupplierTermsAndConditions !== null
                              ? String(newSupplierTermsAndConditions).trim()
                              : "";
                        // Keep isSupplierTermsChanged as true so it gets included in API payload
                        // Don't set to false here - only reset after successful API call
                        setsupplierTermsAndConditions(updatedTerms);
                        setTermsAndConditions(updatedTerms);
                        setNewSupplierTermsAndConditions(updatedTerms);
                        // Keep isSupplierTermsChanged as true so terms are included in payload
                        setShowSubmitBtm(true);
                        setTermsVisible(false);
                      }}
                      className="m-2"
                    >
                      Submit
                    </Button>
                    <Button
                      color="primary"
                      onClick={() => {
                        // Reset to current saved terms (not old value)
                        // Use the actual current state value, not any cached form value
                        const currentTerms = termsAndConditions || "";
                        setIsSupplierTermsChanged(false);
                        // Explicitly reset to empty string if termsAndConditions is empty
                        setNewSupplierTermsAndConditions(currentTerms);
                        // Reset the form with the current terms value
                        methods.reset({
                          supplierTermsAndConditions: currentTerms,
                        });
                        // Also explicitly set the value to ensure it's updated
                        methods.setValue(
                          "supplierTermsAndConditions",
                          currentTerms,
                          { shouldValidate: false, shouldDirty: false }
                        );
                        // Force form field re-render by updating key
                        setTermsFormKey((prev) => prev + 1);
                        // Close the modal
                        setTermsVisible(false);
                      }}
                      className="btn-dim btn btn-secondary m-2"
                    >
                      Cancel
                    </Button>
                  </div>
                )}
              </AntModal>
            </div>
          </div>
        </Card>
      </Content>
    </>
  );
};

export default PublicQuotationForm;
